<template>
	<div>
		<!-- Dialog Add New Item -->
		<DialogPrime v-model:visible="dialog.internalVisible" modal :draggable="false"
			style="width: 70rem; margin: 10px;" class="add-item-modal" @hide="onHide">
			<template #header>
				<div class="d-flex align-items-center gap-2">
					<div>
					<h5 class="mb-0 fw-bold text-dark">{{ readonly ? 'View Item' : (dialog.editingItemId ? 'Edit Item' : 'Add New Item') }}
					</h5>
					</div>
				</div>
			</template>

			<div class="container-fluid px-0">
				<!-- Section: Basic Information -->
				<div v-if="isTabVisibleS('Basic Data & Specification')" class="card mb-2 mt-3"
					:class="{ 'border-danger': dialog.errors.basic }">
					<div class="card-header py-1 d-flex mt-2 mb-2 justify-content-between align-items-center"
						role="button" @click="toggleSection('basic')">
						<div class="d-flex align-items-center flex-wrap gap-2">
							<div class="d-flex align-items-center gap-1">
								<span class="fw-semibold">Basic Data & Specification</span>
								<span v-if="isSectionMandatoryS('Basic Data & Specification')"
									class="text-danger">*</span>
							</div>
							<small v-if="dialog.errors.basic" class="text-danger d-flex align-items-center"
								style="font-style: italic; font-size: 0.75rem;">
								<i class="fas fa-exclamation-circle me-1"></i> {{ dialog.errors.basic }}
							</small>
						</div>
						<i :class="dialog.sections.basic ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
					</div>
					<div v-if="dialog.sections.basic" class="card-body pt-0">
						<div class="row g-3">
							<!-- Material Number selalu di baris sendiri (full-width) di paling atas -->
							<div v-for="field in basicDataOrderedFields" :key="field"
								:class="field === 'material_number' ? 'col-12 mb-2' : 'col-md-6 mb-2'">
								<template v-if="field === 'mcr_code'">
									<label for="mcr-code" class="form-label fw-semibold">MCR Code <span
											class="text-danger">*</span></label>
									<InputText id="mcr-code" v-model="dialog.form.mcr_code" size="small"
										:disabled="isMcrCodeDisabledS" :invalid="!!dialog.errors.mcr_code"
										placeholder="Enter MCR Code" class="w-100" />
								</template>
								<template v-else-if="field === 'material_number'">
									<label for="material-number" class="form-label fw-semibold">{{ isService ? 'Service Number' : 'Material Number' }} <span
											class="text-danger">*</span></label>            <AutoComplete id="material-number" v-model="dialog.form.material_number" size="small"
									:suggestions="materialSuggestions" option-label="label" option-value="value" :force-selection="false"
									:placeholder="isService ? 'Search Service Number...' : 'Search Material Number...'" :min-length="2"
									:loading="materialLoading" show-clear
									:invalid="!!dialog.errors.material_number" fluid @complete="searchMaterial"
									@item-select="onMaterialNumberSelect" @item-unselect="onMaterialClear"
									@clear="onMaterialClear">
									<template #option="{ option }">
										<div>
											<div style="font-size:0.85rem;font-weight:600">{{ option.label }}</div>
											<div style="font-size:0.75rem;color:#6b7280">{{ option.short_text }}</div>
										</div>
									</template>
								</AutoComplete>
								</template>
								<template v-else-if="field === 'material_type'">
									<label for="material-type" class="form-label fw-semibold">Material Type <span
											v-if="isFieldMandatoryS('Basic Data & Specification', 'material_type')"
											class="text-danger">*</span></label>
									<SelectPrime v-model="dialog.form.material_type" size="small"
										:options="materialTypeOptions" option-label="label" option-value="value"
										placeholder="Select Material Type" filter
										panel-class="standard-desc-panel"
										:disabled="!isFieldEnabledS('Basic Data & Specification', 'material_type') || materialTypeLoading"
										:invalid="!!dialog.errors.material_type" class="w-100"
										@show="onMaterialTypeShow" @filter="onMaterialTypeFilter">
										<template #emptyfilter>
											<div v-if="materialTypeLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
										<template #value="{ value, placeholder }">
											<span v-if="value != null && value !== ''" class="select-value-label">{{ getSelectValueLabelS('materialTypeOptions', value) }}</span>
											<span v-else>{{ placeholder }}</span>
										</template>
										<template #empty>
											<div v-if="materialTypeLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
									</SelectPrime>
								</template>
								<template v-else-if="field === 'material_group'">
									<label for="material-group" class="form-label fw-semibold">Material Group <span
											v-if="isFieldMandatoryS('Basic Data & Specification', 'material_group')"
											class="text-danger">*</span></label>
									<SelectPrime v-model="dialog.form.material_group" size="small"
										:options="materialGroupOptions" option-label="label" option-value="value"
										placeholder="Select Material Group" filter
										panel-class="standard-desc-panel"
										:disabled="!isFieldEnabledS('Basic Data & Specification', 'material_group') || materialGroupLoading"
										:invalid="!!dialog.errors.material_group" class="w-100"
										@show="onMaterialGroupShow" @filter="onMaterialGroupFilter">
										<template #emptyfilter>
											<div v-if="materialGroupLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
										<template #value="{ value, placeholder }">
											<span v-if="value != null && value !== ''" class="select-value-label">{{ getSelectValueLabelS('materialGroupOptions', value) }}</span>
											<span v-else>{{ placeholder }}</span>
										</template>
										<template #empty>
											<div v-if="materialGroupLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
									</SelectPrime>
								</template>
								<template v-else-if="field === 'plant'">
									<label for="plant" class="form-label fw-semibold">Plant <span
											v-if="isFieldMandatoryS('Basic Data & Specification', 'plant')"
											class="text-danger">*</span></label>
									<SelectPrime v-model="dialog.form.plant" size="small"
										:options="plantOptions" option-label="label" option-value="value"
										placeholder="Select Plant" filter
										panel-class="standard-desc-panel"
										:disabled="!isFieldEnabledS('Basic Data & Specification', 'plant') || plantLoading"
										:invalid="!!dialog.errors.plant" class="w-100"
										@show="onPlantShow" @filter="onPlantFilter">
										<template #emptyfilter>
											<div v-if="plantLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
										<template #value="{ value, placeholder }">
											<span v-if="value != null && value !== ''" class="select-value-label">{{ getSelectValueLabelS('plantOptions', value) }}</span>
											<span v-else>{{ placeholder }}</span>
										</template>
										<template #empty>
											<div v-if="plantLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
									</SelectPrime>
								</template>
								<template v-else-if="field === 'uom'">
									<label for="uom" class="form-label fw-semibold">UOM <span
											v-if="isFieldMandatoryS('Basic Data & Specification', 'uom')"
											class="text-danger">*</span></label>
									<SelectPrime v-model="dialog.form.uom" size="small"
										:options="uomOptions" option-label="label" option-value="value"
										placeholder="Select UOM" filter
										panel-class="standard-desc-panel"
										:disabled="!isFieldEnabledS('Basic Data & Specification', 'uom') || uomLoading"
										:invalid="!!dialog.errors.uom" class="w-100"
										@show="onUomShow" @filter="onUomFilter">
										<template #emptyfilter>
											<div v-if="uomLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
										<template #empty>
											<div v-if="uomLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
									</SelectPrime>
								</template>
								<template v-else-if="field === 'equipment'">
									<label for="equipment" class="form-label fw-semibold">Equipment <span
										v-if="isFieldMandatoryS('Basic Data & Specification', 'equipment')"
										class="text-danger">*</span></label>
									<SelectPrime v-model="dialog.form.equipment" size="small"
										:options="equipmentOptions" option-label="label" option-value="value"
										placeholder="Select Equipment" filter
										panel-class="standard-desc-panel"
										:disabled="!isFieldEnabledS('Basic Data & Specification', 'equipment') || equipmentLoading"
										:invalid="!!dialog.errors.equipment" class="w-100"														@show="onEquipmentShow" @filter="onEquipmentFilter">
												<template #value="{ value, placeholder }">
													<span v-if="value != null && value !== ''" class="select-value-label">{{ getSelectValueLabelS('equipmentOptions', value) }}</span>
													<span v-else>{{ placeholder }}</span>
												</template>
											<template #emptyfilter>
											<div v-if="equipmentLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
										<template #empty>
											<div v-if="equipmentLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
									</SelectPrime>
								</template>
									<template v-else-if="field === 'currency'">
									<label for="currency" class="form-label fw-semibold">Currency <span
											v-if="isFieldMandatoryS('Basic Data & Specification', 'currency')"
											class="text-danger">*</span></label>
									<Dropdown id="currency" v-model="dialog.form.currency" size="small"
										:invalid="!!dialog.errors.currency" :options="currencyOptions" option-label="label"
										option-value="value" placeholder="Choose Currency"
										:disabled="!isFieldEnabledS('Basic Data & Specification', 'currency')"
										class="w-100" />
								</template>
								<template v-else-if="field === 'price_unit'">
									<label for="price-unit" class="form-label fw-semibold">Price Unit <span
										v-if="isPriceUnitMandatoryS()"
										class="text-danger">*</span></label>
									<InputNumber id="price-unit" v-model="dialog.form.price_unit" size="small"
										:invalid="!!dialog.errors.price_unit"
										:disabled="!isFieldEnabledS('Basic Data & Specification', 'price_unit')"
										placeholder="Enter Price Unit" :use-grouping="false" class="w-100" fluid />
								</template>
								<template v-else-if="field === 'price_reference'">
									<label for="price-reference" class="form-label fw-semibold">Price Reference <span
											v-if="isFieldMandatoryS('Basic Data & Specification', 'price_reference')"
											class="text-danger">*</span></label>
									<InputNumber id="price-reference" v-model="dialog.form.price_reference" size="small"
										:invalid="!!dialog.errors.price_reference"
										:disabled="!isFieldEnabledS('Basic Data & Specification', 'price_reference')"
										placeholder="Enter Price Reference" :use-grouping="true"
										:min-fraction-digits="dialog.form.currency === 'USD' ? 2 : 0"
										:max-fraction-digits="dialog.form.currency === 'USD' ? 2 : 0" class="w-100" fluid />
								</template>
								<template v-else-if="field === 'service_group'">
									<label for="service-group" class="form-label fw-semibold">Service Group <span
											v-if="isFieldMandatoryS('Basic Data & Specification', 'service_group')"
											class="text-danger">*</span></label>
									<SelectPrime v-model="dialog.form.service_group" size="small"
										:options="serviceGroupOptions" option-label="label" option-value="value"
										placeholder="Select Service Group" filter
										panel-class="standard-desc-panel"
										:disabled="!isFieldEnabledS('Basic Data & Specification', 'service_group') || serviceGroupLoading"
										:invalid="!!dialog.errors.service_group" class="w-100"
										@show="onServiceGroupShow" @filter="onServiceGroupFilter">
										<template #emptyfilter>
											<div v-if="serviceGroupLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
										<template #value="{ value, placeholder }">
											<span v-if="value != null && value !== ''" class="select-value-label">{{ getSelectValueLabelS('serviceGroupOptions', value) }}</span>
											<span v-else>{{ placeholder }}</span>
										</template>
										<template #empty>
											<div v-if="serviceGroupLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
									</SelectPrime>
								</template>
								<template v-else-if="field === 'service_category'">
									<label for="service-category" class="form-label fw-semibold">Service Category <span
											v-if="isFieldMandatoryS('Basic Data & Specification', 'service_category')"
											class="text-danger">*</span></label>
									<AutoComplete id="service-category" v-model="dialog.form.service_category" size="small"
										placeholder="Search Service Category..." :suggestions="serviceCategoryOptions"
										option-label="label" :force-selection="true" :min-length="2"
										:invalid="!!dialog.errors.service_category"
										:disabled="!isFieldEnabledS('Basic Data & Specification', 'service_category')" fluid
										@complete="searchServiceCategory" />
								</template>
								<template v-else-if="field === 'valuation_class'">
									<label for="valuation-class" class="form-label fw-semibold">Valuation Class <span
											v-if="isFieldMandatoryS('Basic Data & Specification', 'valuation_class')"
											class="text-danger">*</span></label>
									<SelectPrime v-model="dialog.form.valuation_class" size="small"
										:options="valuationClassOptions" option-label="label" option-value="value"
										placeholder="Select Valuation Class" filter
										panel-class="standard-desc-panel"
										:disabled="!isFieldEnabledS('Basic Data & Specification', 'valuation_class') || valuationClassLoading"
										:invalid="!!dialog.errors.valuation_class" class="w-100"
										@show="onValuationClassShow" @filter="onValuationClassFilter">
										<template #emptyfilter>
											<div v-if="valuationClassLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
										<template #value="{ value, placeholder }">
											<span v-if="value != null && value !== ''" class="select-value-label">{{ getSelectValueLabelS('valuationClassOptions', value) }}</span>
											<span v-else>{{ placeholder }}</span>
										</template>
										<template #empty>
											<div v-if="valuationClassLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
									</SelectPrime>
								</template>
								<template v-else-if="field === 'estimated_annual_usage'">
									<label for="estimated-annual-usage" class="form-label fw-semibold">Estimated Annual
										Usage <span
											v-if="isFieldMandatoryS('Basic Data & Specification', 'estimated_annual_usage')"
											class="text-danger">*</span></label>
									<InputNumber id="estimated-annual-usage" v-model="dialog.form.estimated_annual_usage"
										size="small" :invalid="!!dialog.errors.estimated_annual_usage"
										:disabled="!isFieldEnabledS('Basic Data & Specification', 'estimated_annual_usage')"
										placeholder="Enter Estimated Annual Usage" :use-grouping="true" class="w-100"
										fluid />
								</template>
								<template v-else-if="field === 'standard_description'">
									<label for="standard-description" class="form-label fw-semibold">Standard Description
										<span v-if="isFieldMandatoryS('Basic Data & Specification', 'standard_description')"
											class="text-danger">*</span></label>
									<SelectPrime v-model="dialog.form.standard_description" size="small"
										:options="standardDescriptionOptions" option-label="label" option-value="value"
										placeholder="Select Standard Description" filter
										panel-class="standard-desc-panel"
										:disabled="!isFieldEnabledS('Basic Data & Specification', 'standard_description') || standardDescriptionLoading"
										:invalid="!!dialog.errors.standard_description" class="w-100"
										@show="onStandardDescriptionShow">
										<template #empty>
											<div v-if="standardDescriptionLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
									</SelectPrime>
								</template>
								<template v-else-if="field === 'repairable_item'">
									<label for="repairable-item" class="form-label fw-semibold d-block">Repairable Item
										<span v-if="isFieldMandatoryS('Basic Data & Specification', 'repairable_item')"
											class="text-danger">*</span></label>
									<div class="d-flex align-items-center gap-2">
										<ToggleSwitch v-model="dialog.form.repairable_item" input-id="repairable-item"
											:disabled="!isFieldEnabledS('Basic Data & Specification', 'repairable_item')" />
										<span class="text-muted">{{ dialog.form.repairable_item ? 'Yes' : 'No' }}</span>
									</div>
								</template>
							</div>
						</div>
						<div v-if="specificationVisibleS">
							<label for="specification" class="form-label fw-semibold">Specification <span
								v-if="specificationMandatoryS"
								class="text-danger">*</span></label>
							<PrimeTextarea id="specification" v-model="dialog.form.specification" size="small"
								placeholder="Enter Specification" auto-resize rows="5"
								:invalid="!!dialog.errors.specification"
								:disabled="!specificationEnabledS" fluid />
						</div>
					</div>
				</div>

				<!-- Section: Manufacturer Part Number -->
				<div v-if="isTabVisibleS('Manufacture')" class="card mb-2"
					:class="{ 'border-danger': dialog.errors.manufacturerParts }">
					<div class="card-header py-1 d-flex mt-2 mb-2 justify-content-between align-items-center"
						role="button" @click="toggleSection('attributes')">
						<div class="d-flex align-items-center flex-wrap gap-2">
							<div class="d-flex align-items-center gap-1">
								<span class="fw-semibold">Manufacturer Part Number</span>
								<span v-if="isSectionMandatoryS('Manufacture')" class="text-danger">*</span>
							</div>
							<small
								v-if="dialog.errors.manufacturerParts && typeof dialog.errors.manufacturerParts === 'string'"
								class="text-danger d-flex align-items-center"
								style="font-style: italic; font-size: 0.75rem;">
								<i class="fas fa-exclamation-circle me-1"></i> {{ dialog.errors.manufacturerParts }}
							</small>
						</div>
						<i :class="dialog.sections.attributes ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
					</div>
					<div v-if="dialog.sections.attributes" class="card-body pt-0">
						<div class="d-flex justify-content-end mb-2">
							<button type="button" class="mx-1 mb-0 btn btn-sm btn-primary"
								:disabled="!isFieldEnabledS('Manufacture', 'manufacture')"
								@click="addManuPartRow">Add</button>
						</div>
						<DataTable :value="dialog.form.manufacturerParts" class="compact-table"
							table-style="min-width: 100%; width: max-content;">
							<Column field="manufacture" header-class="bg-light text-dark">
								<template #header>
									<div class="d-flex align-items-center gap-1">
										<span>Manufacturer</span>
										<span v-if="isFieldMandatoryS('Manufacture', 'manufacture')"
											class="text-danger">*</span>
									</div>
								</template>
								<template #body="slotProps">
									<SelectPrime v-model="slotProps.data.manufacture"
										:options="manufacturerOptions" option-label="label" option-value="value"
										filter panel-class="standard-desc-panel"
										:invalid="dialog.validated && isFieldMandatoryS('Manufacture', 'manufacture') && !slotProps.data.manufacture"
										:disabled="!isFieldEnabledS('Manufacture', 'manufacture') || manufacturerLoading"
										placeholder="Search Manufacturer" size="small" fluid
										@show="onManufacturerShow" @filter="onManufacturerFilter">
										<template #emptyfilter>
											<div v-if="manufacturerLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
										<template #value="{ value, placeholder }">
											<span v-if="value != null && value !== ''" class="select-value-label">{{ getSelectValueLabelS('manufacturerOptions', value) }}</span>
											<span v-else>{{ placeholder }}</span>
										</template>
										<template #empty>
											<div v-if="manufacturerLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
									</SelectPrime>
								</template>
							</Column>
							<Column field="manufacture_ref" header-class="bg-light text-dark">
								<template #header>
									<div class="d-flex align-items-center gap-1">
										<span>Manufacturer Ref</span>
										<span v-if="isFieldMandatoryS('Manufacture', 'manufacture_ref')"
											class="text-danger">*</span>
									</div>
								</template>
								<template #body="slotProps">
									<InputText v-model="slotProps.data.manufacture_ref"
										:invalid="dialog.validated && isFieldMandatoryS('Manufacture', 'manufacture_ref') && !slotProps.data.manufacture_ref"
										:disabled="!isFieldEnabledS('Manufacture', 'manufacture_ref')"
										placeholder="Reference" size="small" fluid
										@input="slotProps.data.manufacture_ref = (slotProps.data.manufacture_ref || '').toUpperCase()" />
								</template>
							</Column>
							<Column field="notes" header="Notes" header-class="bg-light text-dark">
								<template #body="slotProps">
									<InputText v-model="slotProps.data.notes"
										:disabled="!isFieldEnabledS('Manufacture', 'manufacture')" placeholder="Notes"
										size="small" fluid />
								</template>
							</Column>
							<Column header="Actions" header-class="bg-light text-dark"
								body-style="text-align: center; width: 80px;">
								<template #body="slotProps">
									<ButtonPrime icon="pi pi-trash" outlined rounded severity="danger" size="small"
										:disabled="!isFieldEnabledS('Manufacture', 'manufacture')"
										@click="deleteManuPartRow(slotProps.index)" />
								</template>
							</Column>
						</DataTable>
					</div>
				</div>

				<!-- Section: Organization Level -->
				<div v-if="isTabVisibleS('Organization Level')" class="card mb-3"
					:class="{ 'border-danger': dialog.errors.org }">
					<div class="card-header py-1 d-flex mt-2 mb-2 justify-content-between align-items-center"
						role="button" @click="toggleSection('org')">
						<div class="d-flex align-items-center flex-wrap gap-2">
							<div class="d-flex align-items-center gap-1">
								<span class="fw-semibold">Organization Level</span>
								<span v-if="isSectionMandatoryS('Organization Level')" class="text-danger">*</span>
							</div>
							<small v-if="dialog.errors.org" class="text-danger d-flex align-items-center"
								style="font-style: italic; font-size: 0.75rem;">
								<i class="fas fa-exclamation-circle me-1"></i> {{ dialog.errors.org }}
							</small>
						</div>
						<i :class="dialog.sections.org ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
					</div>
					<div v-if="dialog.sections.org" class="card-body pt-0">
						<div class="row g-0">
							<!-- Organization Level (readonly from material master) -->
							<div class="col-6 pe-3">
								<div class="mb-2 pb-1 border-bottom">
									<span class="fw-semibold" style="font-size: 0.85rem;">Organization Level
										<small v-if="isSectionReadonlyS('Organization Level', 'organization_level')"
											class="text-muted fw-normal">(from Material Master)</small>
									</span>
								</div>
								<div v-if="isFieldVisibleS('Organization Level', 'plant')" class="org-field">
									<label class="org-label">Plant <span
											v-if="isFieldMandatoryS('Organization Level', 'plant')"
											class="text-danger">*</span></label>
									<div class="org-input">
										<SelectPrime v-model="dialog.form.ext_plant" size="small"
											:options="plantOptions" option-label="label" option-value="value"
											placeholder="Select Plant" filter
											panel-class="standard-desc-panel"
											:disabled="!isSectionEnabledS('Organization Level', 'organization_level') || plantLoading"
											class="w-100"
											@show="onPlantShow" @filter="onPlantFilter">
										<template #emptyfilter>
											<div v-if="plantLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
											<template #value="{ value, placeholder }">
												<span v-if="value != null && value !== ''" class="select-value-label">{{ getSelectValueLabelS('plantOptions', value) }}</span>
												<span v-else>{{ placeholder }}</span>
											</template>
											<template #empty>
												<div v-if="plantLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
													<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
												</div>
												<div v-else class="py-1 text-muted text-center">No options found</div>
											</template>
										</SelectPrime>
									</div>
								</div>
								<div v-if="isFieldVisibleS('Organization Level', 'location') || isFieldVisibleS('Organization Level', 'storage_location')"
									class="org-field">
									<label class="org-label">Location</label>
									<div class="org-input">
										<SelectPrime v-model="dialog.form.ext_location" size="small"
											placeholder="Select Location" :options="storageLocationOptions"
											option-label="label" option-value="value" filter
											panel-class="standard-desc-panel"
											:disabled="!isSectionEnabledS('Organization Level', 'organization_level')"
											fluid @show="onStorageLocationShow" @filter="onStorageLocationFilter">
											<template #emptyfilter>
												<div v-if="storageLocationLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
													<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
												</div>
												<div v-else class="py-1 text-muted text-center">No options found</div>
											</template>
											<template #value="{ value, placeholder }">
												<span v-if="value != null && value !== ''" class="select-value-label">{{ getSelectValueLabelS('storageLocationOptions', value) }}</span>
												<span v-else>{{ placeholder }}</span>
											</template>
											<template #empty>
												<div v-if="storageLocationLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
													<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
												</div>
												<div v-else class="py-1 text-muted text-center">No options found</div>
											</template>
										</SelectPrime>
									</div>
								</div>
								<div v-if="isFieldVisibleS('Organization Level', 'valuation_type')" class="org-field">
									<label class="org-label">Valuation Type</label>
									<div class="org-input">
										<AutoComplete v-model="dialog.form.ext_valuation_type" size="small"
											placeholder="Search Valuation Type..." :suggestions="valuationTypeOptions"
											option-label="label" :force-selection="true" :min-length="2"
											:disabled="!isSectionEnabledS('Organization Level', 'organization_level')"
											fluid @complete="searchValuationType" />
									</div>
								</div>
								<div v-if="isFieldVisibleS('Organization Level', 'sales_org')" class="org-field">
									<label class="org-label">Sales Org.</label>
									<div class="org-input">
										<InputText :value="getFieldLabelS(dialog.form.ext_sales_org)" size="small"
											placeholder="Sales Org."
											:disabled="!isSectionEnabledS('Organization Level', 'organization_level')"
											class="w-100" fluid />
									</div>
								</div>
								<div v-if="isFieldVisibleS('Organization Level', 'distribution_channel') || isFieldVisibleS('Organization Level', 'distr_channel')"
									class="org-field">
									<label class="org-label">Distr. Channel</label>
									<div class="org-input">
										<InputText :value="getFieldLabelS(dialog.form.ext_dist_channel)" size="small"
											placeholder="Distr. Channel"
											:disabled="!isSectionEnabledS('Organization Level', 'organization_level')"
											class="w-100" fluid />
									</div>
								</div>
								<div v-if="isFieldVisibleS('Organization Level', 'warehouse_no')" class="org-field">
									<label class="org-label">Warehouse No.</label>
									<div class="org-input">
										<InputText :value="getFieldLabelS(dialog.form.ext_warehouse_number)"
											size="small" placeholder="Warehouse No."
											:disabled="!isSectionEnabledS('Organization Level', 'organization_level')"
											class="w-100" fluid />
									</div>
								</div>
								<div v-if="isFieldVisibleS('Organization Level', 'storage_type')"
									class="org-field mb-0">
									<label class="org-label">Storage Type</label>
									<div class="org-input">
										<InputText :value="getFieldLabelS(dialog.form.ext_storage_type)" size="small"
											placeholder="Storage Type"
											:disabled="!isSectionEnabledS('Organization Level', 'organization_level')"
											class="w-100" fluid />
									</div>
								</div>
							</div>
							<!-- Copy From (editable fields) -->
							<div class="col-6 ps-3 org-col-divider">
								<div class="mb-2 pb-1 border-bottom">
									<span class="fw-semibold" style="font-size: 0.85rem;">Copy From</span>
								</div>
								<div v-if="isFieldVisibleS('Organization Level', 'plant')" class="copy-field">
									<Dropdown v-model="dialog.copyFrom.ext_cf_plant" size="small"
										placeholder="Select Plant from Material..." :options="copyFromPlantOptions"
										option-label="label" option-value="value"
										:disabled="!isSectionEnabledS('Organization Level', 'copy_from') || !materialDetail"
										class="w-100" />
								</div>
								<div v-if="isFieldVisibleS('Organization Level', 'location') || isFieldVisibleS('Organization Level', 'storage_location')"
									class="copy-field">
									<Dropdown v-model="dialog.copyFrom.ext_cf_location" size="small"
										placeholder="Select Location from Material..."
										:options="copyFromLocationOptions" option-label="label" option-value="value"
										:disabled="!isSectionEnabledS('Organization Level', 'copy_from') || !materialDetail"
										class="w-100" />
								</div>
								<div v-if="isFieldVisibleS('Organization Level', 'valuation_type')" class="copy-field">
									<Dropdown v-model="dialog.copyFrom.ext_cf_valuation_type" size="small"
										placeholder="Select Valuation Type from Material..."
										:options="copyFromValuationTypeOptions" option-label="label"
										option-value="value"
										:disabled="!isSectionEnabledS('Organization Level', 'copy_from') || !materialDetail"
										class="w-100" />
								</div>
								<div v-if="isFieldVisibleS('Organization Level', 'sales_org')" class="copy-field">
									<InputText v-model="dialog.copyFrom.ext_cf_sales_org" size="small"
										placeholder="Sales Org."
										:disabled="readonly || !isFieldEnabledS('Organization Level', 'sales_org') || !isSectionEnabledS('Organization Level', 'copy_from')"
										class="w-100" fluid />
								</div>
								<div v-if="isFieldVisibleS('Organization Level', 'distribution_channel') || isFieldVisibleS('Organization Level', 'distr_channel')"
									class="copy-field">
									<InputText v-model="dialog.copyFrom.ext_cf_dist_channel" size="small"
										placeholder="Distr. Channel"
										:disabled="readonly || !isFieldEnabledS('Organization Level', 'distribution_channel') || !isSectionEnabledS('Organization Level', 'copy_from')"
										class="w-100" fluid />
								</div>
								<div v-if="isFieldVisibleS('Organization Level', 'warehouse_no')" class="copy-field">
									<InputText v-model="dialog.copyFrom.ext_cf_warehouse_number" size="small"
										placeholder="Warehouse No."
										:disabled="readonly || !isFieldEnabledS('Organization Level', 'warehouse_no') || !isSectionEnabledS('Organization Level', 'copy_from')"
										class="w-100" fluid />
								</div>
								<div v-if="isFieldVisibleS('Organization Level', 'storage_type')"
									class="copy-field mb-0">
									<InputText v-model="dialog.copyFrom.ext_cf_storage_type" size="small"
										placeholder="Storage Type"
										:disabled="readonly || !isFieldEnabledS('Organization Level', 'storage_type') || !isSectionEnabledS('Organization Level', 'copy_from')"
										class="w-100" fluid />
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Section: MRP Data -->
				<div v-if="isTabVisibleS('MRP')" class="card mb-2" :class="{ 'border-danger': dialog.errors.mrp }">
					<div class="card-header py-1 d-flex mt-2 mb-2 justify-content-between align-items-center"
						role="button" @click="toggleSection('mrp')">
						<div class="d-flex align-items-center flex-wrap gap-2">
							<div class="d-flex align-items-center gap-1">
								<span class="fw-semibold">MRP Data</span>
								<span v-if="isSectionMandatoryS('MRP')" class="text-danger">*</span>
							</div>
						</div>
						<i :class="dialog.sections.mrp ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
					</div>
					<div v-if="dialog.sections.mrp" class="card-body pt-0">
						<div class="row g-3">
							<div class="col-md-6 mb-2">
								<label class="form-label fw-semibold">Spare Part Category <span
										v-if="isFieldMandatoryS('MRP', 'sparepart_category')"
										class="text-danger">*</span></label>
								<SelectPrime v-model="dialog.form.sparepart_category" size="small"
									:options="sparePartCategoryOptions" option-label="label" option-value="value"
									placeholder="Select Spare Part Category"
									:invalid="dialog.validated && isFieldMandatoryS('MRP', 'sparepart_category') && !dialog.form.sparepart_category"
									:disabled="!isFieldEnabledS('MRP', 'sparepart_category') || sparePartCategoryLoading" class="w-100" />
							</div>
							<div class="col-md-6 mb-2">
								<label class="form-label fw-semibold">MRP Type <span
										v-if="isFieldMandatoryS('MRP', 'mrp_type')" class="text-danger">*</span></label>
								<SelectPrime v-model="dialog.form.mrp_type" size="small"
									:options="mrpTypeOptions" option-label="label" option-value="value"
									placeholder="Select MRP Type" filter
									panel-class="standard-desc-panel"
									:invalid="dialog.validated && isFieldMandatoryS('MRP', 'mrp_type') && !dialog.form.mrp_type"
									:disabled="!isFieldEnabledS('MRP', 'mrp_type') || mrpTypeLoading" class="w-100"
									@show="onMrpTypeShow" @filter="onMrpTypeFilter">
										<template #emptyfilter>
											<div v-if="mrpTypeLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
									<template #value="{ value, placeholder }">
										<span v-if="value != null && value !== ''" class="select-value-label">{{ getSelectValueLabelS('mrpTypeOptions', value) }}</span>
										<span v-else>{{ placeholder }}</span>
									</template>
									<template #empty>
										<div v-if="mrpTypeLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
											<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
										</div>
										<div v-else class="py-1 text-muted text-center">No options found</div>
									</template>
								</SelectPrime>
							</div>
						</div>
						<div class="row g-3">
							<div class="col-md-6 mb-2">
								<label class="form-label fw-semibold">Lot Size <span
										v-if="isFieldMandatoryS('MRP', 'lot_size')" class="text-danger">*</span></label>
								<SelectPrime v-model="dialog.form.lot_size" size="small"
									:options="lotSizeOptions" option-label="label" option-value="value"
									placeholder="Select Lot Size" filter
									panel-class="standard-desc-panel"
									:invalid="dialog.validated && isFieldMandatoryS('MRP', 'lot_size') && !dialog.form.lot_size"
									:disabled="!isFieldEnabledS('MRP', 'lot_size') || lotSizeLoading" class="w-100"
									@show="onLotSizeShow" @filter="onLotSizeFilter">
										<template #emptyfilter>
											<div v-if="lotSizeLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
									<template #value="{ value, placeholder }">
										<span v-if="value != null && value !== ''" class="select-value-label">{{ getSelectValueLabelS('lotSizeOptions', value) }}</span>
										<span v-else>{{ placeholder }}</span>
									</template>
									<template #empty>
										<div v-if="lotSizeLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
											<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
										</div>
										<div v-else class="py-1 text-muted text-center">No options found</div>
									</template>
								</SelectPrime>
							</div>
							<div class="col-md-6 mb-2">
								<label class="form-label fw-semibold">Reorder Point <span
										v-if="isFieldMandatoryS('MRP', 'reorder_point')"
										class="text-danger">*</span></label>
								<InputNumber v-model="dialog.form.reorder_point" size="small"
									:invalid="dialog.validated && isFieldMandatoryS('MRP', 'reorder_point') && (dialog.form.reorder_point === null || dialog.form.reorder_point === '')"
									placeholder="Enter Reorder Point" class="w-100" :use-grouping="false"
									:disabled="!isFieldEnabledS('MRP', 'reorder_point')" fluid />
							</div>
						</div>
						<div class="row g-3">
							<div class="col-md-6 mb-2">
								<label class="form-label fw-semibold">Safety Stock <span
										v-if="isFieldMandatoryS('MRP', 'safety_stock')"
										class="text-danger">*</span></label>
								<InputNumber v-model="dialog.form.safety_stock" size="small"
									:invalid="dialog.validated && isFieldMandatoryS('MRP', 'safety_stock') && (dialog.form.safety_stock === null || dialog.form.safety_stock === '')"
									placeholder="Enter Safety Stock" class="w-100" :use-grouping="false"
									:disabled="!isFieldEnabledS('MRP', 'safety_stock')" fluid />
							</div>
							<div class="col-md-6 mb-2">
								<label class="form-label fw-semibold">ABC Indicator <span
										v-if="isFieldMandatoryS('MRP', 'abc_indicator')"
										class="text-danger">*</span></label>
								<SelectPrime v-model="dialog.form.abc_indicator" size="small"
									:options="abcIndicatorOptions" option-label="label" option-value="value"
									placeholder="Select ABC Indicator" filter
									panel-class="standard-desc-panel"
									:invalid="dialog.validated && isFieldMandatoryS('MRP', 'abc_indicator') && !dialog.form.abc_indicator"
									:disabled="!isFieldEnabledS('MRP', 'abc_indicator') || abcIndicatorLoading" class="w-100"
									@show="onAbcIndicatorShow" @filter="onAbcIndicatorFilter">
										<template #emptyfilter>
											<div v-if="abcIndicatorLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
									<template #value="{ value, placeholder }">
										<span v-if="value != null && value !== ''" class="select-value-label">{{ getSelectValueLabelS('abcIndicatorOptions', value) }}</span>
										<span v-else>{{ placeholder }}</span>
									</template>
									<template #empty>
										<div v-if="abcIndicatorLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
											<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
										</div>
										<div v-else class="py-1 text-muted text-center">No options found</div>
									</template>
								</SelectPrime>
							</div>
						</div>
						<div class="row g-3">
							<div class="col-md-6 mb-2">
								<label class="form-label fw-semibold">Maximum Stock Level <span
										v-if="isFieldMandatoryS('MRP', 'maximum_stock_level')"
										class="text-danger">*</span></label>
								<InputNumber v-model="dialog.form.maximum_stock_level" size="small"
									:invalid="dialog.validated && isFieldMandatoryS('MRP', 'maximum_stock_level') && (dialog.form.maximum_stock_level === null || dialog.form.maximum_stock_level === '')"
									placeholder="Enter Maximum Stock Level" class="w-100" :use-grouping="false"
									:disabled="!isFieldEnabledS('MRP', 'maximum_stock_level')" fluid />
							</div>
							<div class="col-md-6 mb-2">
								<label class="form-label fw-semibold">Rounding Value <span
										v-if="isFieldMandatoryS('MRP', 'rounding_value')"
										class="text-danger">*</span></label>
								<InputNumber v-model="dialog.form.rounding_value" size="small"
									:invalid="dialog.validated && isFieldMandatoryS('MRP', 'rounding_value') && (dialog.form.rounding_value === null || dialog.form.rounding_value === '')"
									placeholder="Enter Rounding Value" class="w-100" :use-grouping="false"
									:disabled="!isFieldEnabledS('MRP', 'rounding_value')" fluid />
							</div>
						</div>
					</div>
				</div>

				<!-- Section: Attachment Document -->
				<div v-if="isTabVisibleS('Attachment of Material')" class="card mb-3"
					:class="{ 'border-danger': dialog.errors.attachments }">
					<div class="card-header py-1 d-flex mt-2 mb-2 justify-content-between align-items-center"
						role="button" @click="toggleSection('attachments')">
						<div class="d-flex align-items-center flex-wrap gap-2">
							<div class="d-flex align-items-center gap-1">
								<span class="fw-semibold">Attachment Document</span>
								<span v-if="isFieldMandatoryS('Attachment of Material', 'file_code')"
									class="text-danger">*</span>
							</div>
							<small v-if="dialog.errors.attachments" class="text-danger d-flex align-items-center"
								style="font-style: italic; font-size: 0.75rem;">
								<i class="fas fa-exclamation-circle me-1"></i> {{ dialog.errors.attachments }}
							</small>
						</div>
						<i :class="dialog.sections.attachments ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
					</div>
					<div v-if="dialog.sections.attachments" class="card-body pt-0">
						<div class="d-flex justify-content-end mb-2">
							<input ref="attachmentInput" type="file" multiple style="display:none"
								accept=".png,.jpg,.jpeg,.pdf,.xls,.xlsx,.doc,.docx"
								@change="onAttachmentSelected" />
							<button type="button" class="mx-1 mb-0 btn btn-sm btn-primary"
								:disabled="!isFieldEnabledS('Attachment of Material', 'file_code')"
								@click="openAttachmentPicker">Add Files</button>
						</div>

						<DataTable :value="dialog.form.attachments" class="compact-table"
							table-style="min-width: 50rem">
							<Column header="File Name" header-class="bg-light text-dark">
								<template #body="slotProps">
									<a v-if="slotProps.data.file_attachment_id"
										class="text-primary text-decoration-underline" style="cursor: pointer;"
										@click="downloadAttachment(slotProps.data)">
										{{ slotProps.data.name || '' }}
									</a>
									<span v-else>{{ slotProps.data.name || '' }}</span>
								</template>
							</Column>
							<Column header="Size" header-class="bg-light text-dark">
								<template #body="slotProps">
									{{ slotProps.data.size ? Math.round(slotProps.data.size / 1024) + ' KB' : '' }}
								</template>
							</Column>
							<Column header="Actions" header-class="bg-light text-dark text-center" style="width: 120px"
								body-style="text-align: center; width: 120px;">
								<template #body="slotProps">
									<ButtonPrime v-if="isPreviewableS(slotProps.data)" v-tooltip.bottom="'Preview'"
										icon="pi pi-eye" outlined rounded severity="info" size="small" class="me-1"
										@click="previewAttachmentS(slotProps.data)" />
									<ButtonPrime icon="pi pi-trash" outlined rounded severity="danger" size="small"
										:disabled="!isFieldEnabledS('Attachment of Material', 'file_code')"
										@click="deleteAttachmentRow(slotProps.index)" />
								</template>
							</Column>
							<template #empty>
								<div class="py-1 text-muted">No Attachments</div>
							</template>
						</DataTable>
					</div>
				</div>

				<!-- Section: Accounting -->
				<div v-if="isTabVisibleS('Accounting')" class="card mb-3"
					:class="{ 'border-danger': dialog.errors.accounting }">
					<div class="card-header py-1 d-flex mt-2 mb-2 justify-content-between align-items-center"
						role="button" @click="toggleSection('accounting')">
						<div class="d-flex align-items-center flex-wrap gap-2">
							<div class="d-flex align-items-center gap-1">
								<span class="fw-semibold">Accounting</span>
								<span v-if="isSectionMandatoryS('Accounting')" class="text-danger">*</span>
							</div>
							<small v-if="dialog.errors.accounting" class="text-danger d-flex align-items-center"
								style="font-style: italic; font-size: 0.75rem;">
								<i class="fas fa-exclamation-circle me-1"></i> {{ dialog.errors.accounting }}
							</small>
						</div>
						<i :class="dialog.sections.accounting ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
					</div>
					<div v-if="dialog.sections.accounting" class="card-body pt-0">
						<div class="row g-3">
							<div v-if="isFieldVisibleS('Accounting', 'valuation_class')" class="col-md-4 mb-2">
								<label class="form-label fw-semibold">Valuation Class <span
										v-if="isFieldMandatoryS('Accounting', 'valuation_class')"
										class="text-danger">*</span></label>
								<SelectPrime v-model="dialog.form.valuation_class" size="small"
									:options="valuationClassOptions" option-label="label" option-value="value"
									placeholder="Select Valuation Class" filter
									panel-class="standard-desc-panel"
									:disabled="readonly || !isFieldEnabledS('Accounting', 'valuation_class')"
									:invalid="dialog.validated && isFieldMandatoryS('Accounting', 'valuation_class') && !dialog.form.valuation_class"
									class="w-100" @show="onValuationClassShow" @filter="onValuationClassFilter">
										<template #emptyfilter>
											<div v-if="valuationClassLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
												<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
											</div>
											<div v-else class="py-1 text-muted text-center">No options found</div>
										</template>
									<template #value="{ value, placeholder }">
										<span v-if="value != null && value !== ''" class="select-value-label">{{ getSelectValueLabelS('valuationClassOptions', value) }}</span>
										<span v-else>{{ placeholder }}</span>
									</template>
									<template #empty>
										<div v-if="valuationClassLoading" class="d-flex align-items-center justify-content-center gap-2 py-2">
											<i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
										</div>
										<div v-else class="py-1 text-muted text-center">No options found</div>
									</template>
								</SelectPrime>
							</div>
							<div v-if="isFieldVisibleS('Accounting', 'price_control')" class="col-md-4 mb-2">
								<label class="form-label fw-semibold">Price Control <span
										v-if="isFieldMandatoryS('Accounting', 'price_control')"
										class="text-danger">*</span></label>
								<SelectPrime v-model="dialog.form.price_control" size="small"
									:options="priceControlOptions" option-label="label" option-value="code"
									placeholder="Select"
									:disabled="readonly || !isFieldEnabledS('Accounting', 'price_control')"
									:invalid="dialog.validated && isFieldMandatoryS('Accounting', 'price_control') && !dialog.form.price_control"
									class="w-100" />
							</div>
							<div v-if="isFieldVisibleS('Accounting', 'standard_price')" class="col-md-4 mb-2">
								<label class="form-label fw-semibold">Standard Price <span
										v-if="isFieldMandatoryS('Accounting', 'standard_price')"
										class="text-danger">*</span></label>
								<InputNumber v-model="dialog.form.standard_price" size="small" placeholder="0.00"
									:min="0" :min-fraction-digits="2"
									:disabled="readonly || !isFieldEnabledS('Accounting', 'standard_price')"
									class="w-100" fluid />
							</div>
						</div>
					</div>
				</div>

				<!-- Additional Notes (Optional) -->
				<div v-if="isTabVisibleS('Notes')" class="card mb-3" :class="{ 'border-danger': dialog.errors.notes }">
					<div class="card-header py-1 d-flex mt-2 mb-2 justify-content-between align-items-center"
						role="button" @click="toggleSection('notes')">
						<div class="d-flex align-items-center flex-wrap gap-2">
							<div class="d-flex align-items-center gap-1">
								<span class="fw-semibold">Notes</span>
								<span v-if="isFieldMandatoryS('Notes', 'notes')" class="text-danger">*</span>
							</div>
							<small v-if="dialog.errors.notes" class="text-danger d-flex align-items-center"
								style="font-style: italic; font-size: 0.75rem;">
								<i class="fas fa-exclamation-circle me-1"></i> {{ dialog.errors.notes }}
							</small>
						</div>
						<i :class="dialog.sections.notes ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
					</div>
					<div v-if="dialog.sections.notes" class="card-body pt-0">
						<div class="row g-3">
							<div class="col-md-12 mb-2">
								<label class="form-label fw-semibold">Notes <span
										v-if="isFieldMandatoryS('Notes', 'notes')" class="text-danger">*</span></label>
								<PrimeTextarea v-model="dialog.form.notes" size="small"
									:invalid="dialog.validated && isFieldMandatoryS('Notes', 'notes') && !dialog.form.notes"
									placeholder="Write notes" auto-resize rows="3" class="w-100"
									:disabled="!isFieldEnabledS('Notes', 'notes')" fluid />
							</div>
						</div>
					</div>
				</div>
			</div>

		<template #footer>
			<div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
				<ButtonPrime type="button" :label="readonly ? 'Close' : 'Cancel'" severity="danger" raised size="small"
					class="px-4 border-0" @click="closeDialog" />
				<ButtonPrime v-if="!readonly" type="button" severity="contrast" raised size="small" :disabled="dialog.onLoading"
					:label="dialog.editingItemId ? 'Update Item' : 'Save Item'" class="px-4" @click="saveForm">
					<template v-if="dialog.onLoading" #icon>
						<i class="fas fa-spinner fa-spin me-2"></i>
					</template>
				</ButtonPrime>
			</div>
		</template>
		</DialogPrime>

		<!-- Dialog Preview PDF -->
		<DialogPrime v-model:visible="previewModal.visible" modal :header="previewModal.title"
			:style="{ width: '95vw', maxHeight: '95vh', margin: '10px' }"
			:pt="{ mask: { style: 'backdrop-filter: blur(5px); background: rgba(0,0,0,0.3);' }, content: { style: 'background: transparent; border: none; box-shadow: none;' }, header: { style: 'background: rgba(255,255,255,0.95); backdrop-filter: blur(10px); border-radius: 12px 12px 0 0;' }, closeButton: { style: 'background: rgba(255,255,255,0.95); backdrop-filter: blur(10px);' } }">
			<iframe v-if="previewModal.pdfUrl" :src="previewModal.pdfUrl + '#zoom=150'" class="pdf-iframe"></iframe>
		</DialogPrime>

		<!-- Native Image Preview Trigger (Hidden) -->
		<div style="position: absolute; width: 0; height: 0; overflow: hidden;">
			<PrimeImage ref="imagePreviewer" :src="previewModal.imageUrl" preview @load="onPreviewImageLoadS" />
		</div>
	</div>
</template>

<script>
import userFormService from '@/services/materialCatalogingRequest/userFormService';
import euMaterialService from '@/services/generalMasterData/euMaterialService';
import generalMasterDataService from "@/services/generalMasterData/generalMasterDataService";
import manufacturerService from "@/services/generalMasterData/manufacturerService";
import draftListService from '@/services/materialCatalogingRequest/draftListService';
import advanceSearchService from '@/services/generalLayout/advanceSearchService';
import serviceAdvanceService from '@/services/generalLayout/serviceAdvanceService';
import smartcatAttachmentService from '@/services/dictionary/smartcatAttachmentService';
import formConfigHelper from '@/helpers/formConfig';
import materialNumberFormatter from '@/helpers/materialNumberFormatter';
import api from "@/helpers/api";
export default {
	name: 'McrItemFormDialog',
	props: {
		formConfig: { type: Object, default: null },
		viewData: { type: Object, default: null },
		readonly: { type: Boolean, default: false },
		clientCode: { type: String, default: '' },
		companyCode: { type: String, default: '' },
		mcrType: { type: String, default: '' },
		maxValidation: {
			type: Object,
			default: () => ({ size: 2000000, text: 'Max Size 2000 KB' })
		},
		draftId: { type: [String, Number], default: null },
		localMode: { type: Boolean, default: false },
	},
	emits: ['saved', 'close'],
	expose: ['openForAdd', 'openForEdit', 'openForLocalEdit'],
	data() {
		return {
			dialog: {
				internalVisible: false,
				onLoading: false,
				validated: false,
				errors: {},
				editingItemId: null,
				sections: { basic: true, attributes: true, mrp: true, attachments: true, notes: true, org: true, accounting: true },
				isMaterialSelected: false,
				form: this.emptyRow(),
				copyFrom: this.emptyCopyFrom(),
			},
			mrpDefaults: {},
			previewModal: {
				visible: false,
				title: '',
				pdfUrl: '',
				imageUrl: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
			},
			// Opsi tambahan dari material detail (bukan IDR/USD) — di-merge ke computed currencyOptions
			extraCurrencyOptions: [],
			standardDescriptionOptions: [],
			// Lazy load: opsi baru di-fetch saat dropdown diklik (bukan saat dialog dibuka).
			standardDescriptionLoading: false,
			materialSuggestions: [],
			materialLoading: false,
			materialTypeOptions: [],
			// Lazy load saat dropdown diklik (onMaterialTypeShow) + filter search API.
			materialTypeLoading: false,
			materialTypeFilterTimer: null,
			materialTypeSearchedQueries: [],
			materialGroupOptions: [],
			// Lazy load saat dropdown diklik (onMaterialGroupShow) + filter search API.
			materialGroupLoading: false,
			materialGroupFilterTimer: null,
			materialGroupSearchedQueries: [],
			serviceGroupOptions: [],
			// Lazy load saat dropdown diklik (onServiceGroupShow) + filter search API.
			serviceGroupLoading: false,
			serviceGroupFilterTimer: null,
			serviceGroupSearchedQueries: [],
			serviceCategoryOptions: [],
			plantOptions: [],
			// Lazy load saat dropdown diklik (onPlantShow) + filter search API.
			plantLoading: false,
			plantFilterTimer: null,
			plantSearchedQueries: [],
			uomOptions: [],
			// State pencarian UOM (limit 10): timer debounce & query yang sudah dicari.
			uomFilterTimer: null,
			uomSearchedQueries: [],
			// Lazy load: opsi baru di-fetch saat dropdown diklik (bukan saat dialog dibuka).
			uomLoading: false,
			equipmentOptions: [],
			// State pencarian Equipment (limit 10): timer debounce & query yang sudah
			// dicari ke API supaya tidak fetch ganda.
			equipmentFilterTimer: null,
			equipmentSearchedQueries: [],
			// Lazy load: opsi baru di-fetch saat dropdown diklik (bukan saat dialog dibuka).
			equipmentLoading: false,
			lotSizeOptions: [],
			// Lazy load saat dropdown diklik (onLotSizeShow) + filter search API.
			lotSizeLoading: false,
			lotSizeFilterTimer: null,
			lotSizeSearchedQueries: [],
			abcIndicatorOptions: [],
			// Lazy load saat dropdown diklik (onAbcIndicatorShow) + filter search API.
			abcIndicatorLoading: false,
			abcIndicatorFilterTimer: null,
			abcIndicatorSearchedQueries: [],
			sparePartCategoryOptions: [],
			sparePartCategoryLoading: false,
			valuationClassOptions: [],
			// Lazy load saat dropdown diklik (onValuationClassShow) + filter search API.
			valuationClassLoading: false,
			valuationClassFilterTimer: null,
			valuationClassSearchedQueries: [],
			mrpTypeOptions: [],
			// Lazy load saat dropdown diklik (onMrpTypeShow) + filter search API.
			mrpTypeLoading: false,
			mrpTypeFilterTimer: null,
			mrpTypeSearchedQueries: [],
			manufacturerOptions: [],
			// Lazy load saat dropdown diklik (onManufacturerShow) + filter search API.
			manufacturerLoading: false,
			manufacturerFilterTimer: null,
			manufacturerSearchedQueries: [],
			storageLocationOptions: [],
			storageLocationLoading: false,
			storageLocationFilterTimer: null,
			storageLocationSearchedQueries: [],
			valuationTypeOptions: [],
			priceControlOptions: [],
			materialDetail: null,
			copyFromPlantOptions: [],
			copyFromLocationOptions: [],
			copyFromValuationTypeOptions: [],
			secondary: {
				optPlant: [],
				optValuationType: [
					{ label: 'ZNORMAL', code: 'ZNORMAL' },
					{ label: 'ZDAMAGE', code: 'ZDAMAGE' },
					{ label: 'ZRECOND', code: 'ZRECOND' },
					{ label: 'ZSURP-EXT', code: 'ZSURP-EXT' },
					{ label: 'ZSURP-INT1', code: 'ZSURP-INT1' }
				],
				optStorageLoc: [],
			},
		};
	},
	computed: {
		// Currency options dari form-config + extra dari material detail
		currencyOptions() {
			const config = formConfigHelper.getFieldConfig(this.formConfig, 'Basic Data & Specification', 'currency');
			const base = Array.isArray(config?.options) ? config.options : [];
			// Merge extraCurrencyOptions (dari material detail) tanpa duplikat
			const merged = new Map(base.map(o => [o.value, o]));
			this.extraCurrencyOptions.forEach(o => {
				if (!merged.has(o.value)) merged.set(o.value, o);
			});
			return Array.from(merged.values());
		},
		hasMaterialNumberFieldS() {
			return formConfigHelper.isFieldVisible(this.formConfig, 'Basic Data & Specification', 'material_number', this.formConfigCtxS);
		},
		// MCR type service (MCR008/MCR009) → label & placeholder material number jadi "Service Number"
		isService() {
			const t = (this.mcrType || '').toLowerCase();
			return t === 'mcr008' || t === 'mcr009' || t.includes('service');
		},
		isMcrCodeDisabledS() {
			return Boolean(this.viewData && this.viewData.mcr_code);
		},
		specificationVisibleS() {
			return this.isFieldVisibleS('Basic Data & Specification', 'specification') || this.isFieldVisibleS('description_material', 'specification');
		},
		specificationMandatoryS() {
			return this.isFieldMandatoryS('Basic Data & Specification', 'specification') || this.isFieldMandatoryS('description_material', 'specification');
		},
		specificationEnabledS() {
			return this.isFieldEnabledS('Basic Data & Specification', 'specification') && this.isFieldEnabledS('description_material', 'specification');
		},
		// Fields of Basic Data & Specification ordered by form-config (then known-but-unconfigured fields)
		basicDataOrderedFields() {
			const canonical = ['mcr_code', 'material_number', 'material_type', 'material_group', 'plant', 'equipment', 'uom', 'currency', 'price_unit', 'price_reference', 'service_group', 'service_category', 'valuation_class', 'estimated_annual_usage', 'standard_description', 'repairable_item'];
			// NOTE: service_group/service_category must stay in `canonical` so they enter `visible` (and thus `top`).
			const visible = canonical.filter(f => {
				if (f === 'material_number') return this.hasMaterialNumberFieldS;
				if (f === 'price_unit') return this.isPriceUnitFieldVisibleS();
				return this.isFieldVisibleS('Basic Data & Specification', f);
			});
			const configKeys = this.configFieldNamesS('Basic Data & Specification');
			// Material Number di-pin paling atas & sendirian (full-width di template).
			// Material (urutan per baris 2 kolom): Material Type & Material Group,
			// lalu UOM & Valuation Class, lalu Plant & Equipment, lalu Currency & Price Unit.
			// Service: service_category & service_group tetap di atas (tidak berubah).
			const pinnedTop = this.isService
				? ['material_number', 'service_category', 'service_group']
				: ['material_number', 'material_type', 'material_group', 'uom', 'valuation_class', 'plant', 'equipment', 'currency', 'price_unit'];
			// Filter dari pinnedTop supaya urutan (material_number, service_category, service_group) terjaga
			const top = pinnedTop.filter(f => visible.includes(f));
			const rest = visible.filter(f => !pinnedTop.includes(f));
			// Remaining fields follow the form-config order (config keys first, then known-but-unconfigured fields)
			const inConfig = configKeys.filter(f => rest.includes(f));
			const notInConfig = rest.filter(f => !configKeys.includes(f));
			const ordered = [...top, ...inConfig, ...notInConfig];
			// Tukar posisi Repairable Item & Estimated Annual Usage — dipaksa di hasil akhir
			// supaya tetap berlaku walau urutan dari config server berbeda.
			const riIdx = ordered.indexOf('repairable_item');
			const eauIdx = ordered.indexOf('estimated_annual_usage');
			if (riIdx !== -1 && eauIdx !== -1) {
				ordered[riIdx] = 'estimated_annual_usage';
				ordered[eauIdx] = 'repairable_item';
			}
			// Only known fields are rendered; unknown config fields are skipped (same as legacy behavior,
			// and their values are not part of the saveForm payload)
			return ordered;
		},
		currentMaterialTypeValueS() {
			const mt = this.dialog.form.material_type;
			return typeof mt === 'object' ? (mt?.value || '') : (mt || '');
		},

		formConfigCtxS() {
			return {
				getField: (name) => {
					if (name === 'cat_material_type' || name === 'material_type') return this.currentMaterialTypeValueS;
					if (name === 'material_number') {
						// Hanya dianggap "terisi" setelah user BENAR-BENAR memilih material dari suggestions
						// (isMaterialSelected true — di-set di fetchMaterialDetailS). Selama masih mengetik/
						// mencari, dikembalikan kosong supaya field lain dengan is_enabled condition
						// { material_number: true } (notes/specification/attachment) tetap disabled.
						if (!this.dialog.isMaterialSelected) return '';
						const val = this.dialog.form.material_number;
						if (val && typeof val === 'object') return val.value || val.label || '';
						return val || '';
					}
					return this.dialog.form[name];
				},
				hasLine: (section) => {
					if (section === 'emcr_manufacturers' || section === 'Manufacture') return this.dialog.form.manufacturerParts?.length > 0;
					return false;
				}
			};
		},
	},
	// Flag to skip resetDisabledFieldsS during openForEdit/openForLocalEdit initialization.
	// Prevents the watcher from resetting pre-filled form values (e.g. UOM) when
	// material_type transitions from '' to the saved value during async setup.
	_skipResetDisabled: false,
	watch: {
		currentMaterialTypeValueS() {
			if (this._skipResetDisabled) return;
			// Material Type mengontrol enable/disable field lain (is_enabled condition),
			// jadi wajib reset ulang. TIDAK ada fetch API di sini — sama seperti UOM:
			// label di-resolve di awal (loadDialogOptionsS), search hanya via @complete
			// (min 2 karakter). Memilih opsi tidak memicu API call tambahan.
			this.resetDisabledFieldsS();
		},
		'previewModal.visible'(val) {
			if (!val && this.previewModal.pdfUrl) {
				URL.revokeObjectURL(this.previewModal.pdfUrl);
				this.previewModal.pdfUrl = '';
			}
		},
		'dialog.form.ext_plant'() {
			this.storageLocationOptions = [];
		},
	},
	methods: {
		emptyRow() {
			return {
				mcr_code: '',        material_number: '',
				material_number_raw: '',
				material_type: '',
				material_group: '',
				item_type: '',
				plant: '',
				uom: '',
				equipment: '',
				currency: '',
				price_reference: null,
				price_unit: null,
				service_group: '',
				service_category: '',
				specification: '',
				descriptions: '',
				notes: '',
				valuation_class: '',
				standard_description: '',
				estimated_annual_usage: null,
				repairable_item: null,
				manufacturerParts: [{ manufacture: '', manufacture_ref: '', notes: '' }],
				equipments: [],
				attachments: [],
				sparepart_category: '',
				mrp_type: '',
				lot_size: '',
				reorder_point: null,
				safety_stock: null,
				abc_indicator: '',
				maximum_stock_level: null,
				rounding_value: null,
				// Organization Level fields (ext_ prefix for EXTEND-MATERIAL)
				ext_plant: '',
				ext_location: '',
				ext_valuation_type: '',
				ext_sales_org: '',
				ext_dist_channel: '',
				ext_warehouse_number: '',
				ext_storage_type: '',
				// Accounting fields
				price_control: '',
				standard_price: null,
			};
		},

		// === Public methods (exposed) ===
		async openForAdd() {
			this.dialog.editingItemId = null;
			this.resetForm();
			this.dialog.copyFrom = this.emptyCopyFrom();
			this.applyConfigDefaultsS();
			this.dialog.internalVisible = true;
			// Add mode: hanya load opsi esensial (resolveAutoCompleteDefaults + priceControls).
			// Dropdown lain (material-type, plant, UOM, dll.) di-load lazy saat user klik.
			await this.loadDialogOptionsS();
		},

		async openForLocalEdit(formData, editIndex) {
			this._skipResetDisabled = true;
			try {
			this.dialog.editingItemId = editIndex;
			this.dialog.form = { ...this.emptyRow(), ...formData };
			// Format material_number untuk tampilan, simpan raw untuk API
			if (this.dialog.form.material_number && !this.dialog.form.material_number_raw) {
				this.dialog.form.material_number_raw = this.dialog.form.material_number;
			}
			if (this.dialog.form.material_number_raw) {
				this.dialog.form.material_number = materialNumberFormatter.formatMaterialNumber(this.dialog.form.material_number_raw);
			}
			this.dialog.copyFrom = this.emptyCopyFrom();
			this.dialog.validated = false;
			this.dialog.errors = {};
			this.dialog.isMaterialSelected = !!formData.material_number;
			this.clearSuggestions();
			this.dialog.internalVisible = true;
			// Local edit: data sudah ada di form, hanya load opsi esensial.
			// Dropdown lain di-load lazy saat user klik.
			await this.loadDialogOptionsS();
			// Pastikan nilai tersimpan tampil terpilih walau opsi belum dimuat.
			this.ensureOptionVisibleS('materialTypeOptions', 'material_type');
			this.ensureOptionVisibleS('materialGroupOptions', 'material_group');
			this.ensureOptionVisibleS('valuationClassOptions', 'valuation_class');
			this.ensureOptionVisibleS('serviceGroupOptions', 'service_group');
			this.ensureOptionVisibleS('mrpTypeOptions', 'mrp_type');
			this.ensureOptionVisibleS('lotSizeOptions', 'lot_size');				this.ensureOptionVisibleS('abcIndicatorOptions', 'abc_indicator');
				this.ensureOptionVisibleS('uomOptions', 'uom');
			this.ensureOptionVisibleS('equipmentOptions', 'equipment');
			this.ensureOptionVisibleS('plantOptions', 'plant');
			this.ensureOptionVisibleS('plantOptions', 'ext_plant');
			} finally { this._skipResetDisabled = false; }
		},

		async openForEdit(itemId) {
			this._skipResetDisabled = true;
			this.dialog.onLoading = true;
			try {
				if (!this.draftId) {
					this.$toastNotifPrime('error', 'Error', 'Draft ID not found');
					this.dialog.onLoading = false;
					return;
				}
				const response = await api(this, draftListService.detail(this.draftId), false);
				let details = null;
				if (response?.data?.data) details = response.data.data;
				else if (response?.data) details = response.data;
				else if (response) details = response;

				if (!details || !Array.isArray(details.emcr_item)) {
					this.dialog.onLoading = false;
					return;
				}
				console.log("openForEdit", JSON.stringify(this.openForEdit))
				const matched = details.emcr_item.find(it => it.id === itemId);
				const itemData = matched || {};

				let attachments = [];
				const atts = Array.isArray(itemData.emcr_item_attachment) ? itemData.emcr_item_attachment : (itemData.emcr_item_attachment ? [itemData.emcr_item_attachment] : []);
				if (atts.length) {
					try {
						attachments = await Promise.all(atts.map(async (a) => {
							const fid = a?.file_attachment?.id;
							const filename = a?.file_attachment?.original_filename || a?.file_attachment?.file_name || a?.file_code || 'attachment';
							const fileSize = a?.file_attachment?.file_size ? Number(a.file_attachment.file_size) : 0;
							return {
								name: filename,
								size: fileSize,
								file_code: a?.file_code,
								file_attachment_id: fid,
								mime_type: a?.file_attachment?.mime_type || ''
							};
						}));
					} catch (e) {
						attachments = this.parseAttachmentsS(itemData.emcr_item_attachment);
					}
				}

				const mrpRows = Array.isArray(itemData.emcr_item_plant) ? itemData.emcr_item_plant : [];
				const mrp = mrpRows.find(r => r.plant === itemData.plant) || mrpRows[0] || {};

				const valuationRows = Array.isArray(itemData.emcr_item_valuation) ? itemData.emcr_item_valuation : [];
				const valuation = valuationRows[0] || {};

				// Simpan account_category_ref dari catalog_material_type supaya
				// getValuationAccCatRefS() bisa akses langsung tanpa depends options cache.
				const matTypeDetail = itemData.catalog_material_type || itemData.material_type_detail || null;
				this.dialog._editAccCatRef = matTypeDetail?.account_category_ref || null;
				this.dialog._editServiceCatAccCatRef = (itemData.catalog_service_category || itemData.service_category_detail || null)?.account_category_ref || null;
				this.dialog.isMaterialSelected = !!itemData.material_number;
				this.dialog.form = {
					mcr_code: itemData.mcr_code || (details && details.mcr_code) || '',
					material_number: materialNumberFormatter.formatMaterialNumber(itemData.material_number || ''),
					material_number_raw: itemData.material_number || '',
					material_type: itemData.material_type || '',
					material_group: itemData.material_group || '',
					plant: itemData.plant || '',
					uom: itemData.uom || '',
					equipment: itemData.equipment || '',
					currency: itemData.currency || '',
					price_reference: itemData.price_reference != null ? Number(itemData.price_reference) : null,
					price_unit: itemData.price_unit != null ? Number(itemData.price_unit) : (itemData.unit_price != null ? Number(itemData.unit_price) : null),
					service_group: itemData.service_group || itemData.cat_service_group || '',
					service_category: itemData.service_category || itemData.cat_service_category || '',
					specification: itemData.specification || '',
					descriptions: itemData.specification || '',
					valuation_class: valuation.valuation_class || itemData.valuation_class || '',
					standard_description: itemData.standard_description || '',
					estimated_annual_usage: itemData.estimated_annual_usage != null ? Number(itemData.estimated_annual_usage) : null,
					repairable_item: itemData.repairable_item != null ? itemData.repairable_item : null,
					// Notes bisa tersimpan di emcr_item_note (array) atau langsung di field notes item
					// (string) — fallback supaya tidak kosong saat edit (mis. MCR service).
					notes: this.parseNotesS(itemData.emcr_item_note) || this.parseNotesS(itemData.notes) || '',
					manufacturerParts: this.parseManufacturerPartsS(itemData.emcr_item_manufacturer),
					attachments,
					sparepart_category: mrp.sparepart_category || mrp.spare_part_category || '',
					mrp_type: mrp.mrp_type || '',
					lot_size: mrp.lot_size || '',
					reorder_point: mrp.reorder_point != null && mrp.reorder_point !== '' ? Number(mrp.reorder_point) : null,
					safety_stock: mrp.safety_stock != null && mrp.safety_stock !== '' ? Number(mrp.safety_stock) : null,
					abc_indicator: mrp.abc_indicator || '',
					maximum_stock_level: mrp.maximum_stock_level != null && mrp.maximum_stock_level !== '' ? Number(mrp.maximum_stock_level) : null,
					rounding_value: mrp.rounding_value != null && mrp.rounding_value !== '' ? Number(mrp.rounding_value) : null,
					// Organization Level fields (EXTEND-MATERIAL naming)
					ext_plant: itemData.ext_plant || itemData.plant || '',
					ext_location: itemData.ext_location || itemData.storage_location || '',
					ext_valuation_type: itemData.ext_valuation_type || itemData.valuation_type || '',
					ext_sales_org: itemData.ext_sales_org || itemData.sales_org || '',
					ext_dist_channel: itemData.ext_dist_channel || itemData.distr_channel || '',
					ext_warehouse_number: itemData.ext_warehouse_number || itemData.warehouse_no || '',
					ext_storage_type: itemData.ext_storage_type || itemData.storage_type || '',
					// Accounting fields (from emcr_item_valuation)
					price_control: valuation.price_control || '',
					standard_price: valuation.std_price != null && valuation.std_price !== '' ? Number(valuation.std_price) : null,
				};
				this.dialog.editingItemId = itemData.id || itemId || null;
				this.dialog.copyFrom = {
					ext_cf_plant: itemData.ext_cf_plant || '',
					ext_cf_location: itemData.ext_cf_location || '',
					ext_cf_valuation_type: itemData.ext_cf_valuation_type || '',
					ext_cf_sales_org: itemData.ext_cf_sales_org || '',
					ext_cf_dist_channel: itemData.ext_cf_dist_channel || '',
					ext_cf_warehouse_number: itemData.ext_cf_warehouse_number || '',
					ext_cf_storage_type: itemData.ext_cf_storage_type || '',
				};
				this.dialog.validated = false;
				this.dialog.errors = {};
				this.clearSuggestions();
				this.dialog.internalVisible = true;
				this.dialog.onLoading = false;
				// Edit mode: load master data (optPlant/optStorageLoc/optValuationType) dulu
				// supaya Copy From options punya label lengkap.
				await this.loadOptions();
				// Pastikan saved value tetap tampil walau API belum resolve (fallback kode).
				this.ensureOptionVisibleS('materialTypeOptions', 'material_type');
				this.ensureOptionVisibleS('materialGroupOptions', 'material_group');
				this.ensureOptionVisibleS('valuationClassOptions', 'valuation_class');
				this.ensureOptionVisibleS('serviceGroupOptions', 'service_group');
				this.ensureOptionVisibleS('mrpTypeOptions', 'mrp_type');
				this.ensureOptionVisibleS('lotSizeOptions', 'lot_size');
				this.ensureOptionVisibleS('abcIndicatorOptions', 'abc_indicator');
				this.ensureOptionVisibleS('uomOptions', 'uom');
				this.ensureOptionVisibleS('equipmentOptions', 'equipment');
				this.ensureOptionVisibleS('plantOptions', 'plant');
				this.ensureOptionVisibleS('plantOptions', 'ext_plant');
				// Load pararel tiap field dengan search param = kode tersimpan,
				// supaya label lengkap (bukan cuma kode) langsung tampil saat dialog dibuka.
				// Disable field sementara loading supaya user tahu masih diproses.
				this.materialTypeLoading = true;
				this.materialGroupLoading = true;
				this.plantLoading = true;
				this.valuationClassLoading = true;
				this.serviceGroupLoading = true;
				this.mrpTypeLoading = true;
				this.lotSizeLoading = true;
				this.abcIndicatorLoading = true;
				this.uomLoading = true;
				this.equipmentLoading = true;
				this.standardDescriptionLoading = true;
				this.manufacturerLoading = true;
				this.storageLocationLoading = true;
				// resolveOnly: hanya resolve label ke form value, tidak populate dropdown options.
				// Dropdown akan diisi saat user klik (onXxxShow) dengan API tanpa search.
				Promise.all([
					this.loadMaterialTypeOptions(false, true),
					this.loadMaterialGroupOptions(false, true),
					this.loadPlantOptions(false, true),
					// Resolve label ext_plant (Organization Level) — share plantOptions dengan plant Basic Data.
					this.loadMasterDataSelectS('plant', 'ext_plant', 'plantOptions', m => this.masterDataOptionLabelS(m), { limit: 10 }, { resolveOnly: true }),
					this.loadValuationClassOptions(false, true),
					this.loadServiceGroupOptions(false, true),
					this.loadMrpTypeOptions(false, true),
					this.loadLotSizeOptions(false, true),
					this.loadAbcIndicatorOptions(false, true),
					this.loadUomOptions(false, true),
					this.loadEquipmentOptions(false, true),
					this.loadStandardDescriptions(false, true),
					this.loadManufacturerOptions(true),
					this.loadSparePartCategories(false, true),
					this.loadStorageLocationOptions(false, true),
				]).finally(() => {
					this.materialTypeLoading = false;
					this.materialGroupLoading = false;
					this.plantLoading = false;
					this.valuationClassLoading = false;
					this.serviceGroupLoading = false;
					this.mrpTypeLoading = false;
					this.lotSizeLoading = false;
					this.abcIndicatorLoading = false;
					this.uomLoading = false;
					this.equipmentLoading = false;
					this.standardDescriptionLoading = false;
					this.manufacturerLoading = false;
					this.storageLocationLoading = false;
					// Resolve ext_plant label dari plantOptions yang sudah terisi
					// (share array dengan plant, jadi tidak boleh pararel — resolve setelah selesai).
					this.resolveMasterDataSelectValueS(this.plantOptions, 'ext_plant', 'plantOptions', m => this.masterDataOptionLabelS(m));
				});
					if (itemData.material_number) {
					if (this.isService) {
						// service_group sudah SelectPrime → nilai tetap string kode, tidak
						// perlu wrap {label, value} (itu pola lama AutoComplete).
					} else {
						// Material (MCR002 dkk): Bangun materialDetail dari itemData
						// (tetap sama seperti sebelumnya supaya field lain tidak terdampak).
						this.materialDetail = {
							material_number: itemData.material_number,
							eu_material_plant: itemData.emcr_item_plant || [],
							eu_material_location: itemData.cat_emcr_item_location || itemData.emcr_item_location || [],
							eu_material_valuation: itemData.emcr_item_valuation || [],
						};
						this.populateCopyFromOptionsS(
							this.materialDetail.eu_material_plant,
							this.materialDetail.eu_material_location,
							this.materialDetail.eu_material_valuation
						);
						// Fetch material detail HANYA buat Copy From options (plant lengkap)
						// hanya jika section copy_from aktif di form config (MCR003 dkk)
						if (this.isSectionEnabledS('Organization Level', 'copy_from')) {
							try {
								const matRes = await api(this, advanceSearchService.getMaterialDetail(itemData.material_number), false);
								const matDetail = matRes?.data?.data || matRes?.data || null;
								if (matDetail) {
									this.populateCopyFromOptionsS(
										matDetail.eu_material_plant || this.materialDetail.eu_material_plant,
										matDetail.eu_material_location || this.materialDetail.eu_material_location,
										matDetail.eu_material_valuation || this.materialDetail.eu_material_valuation
								);
								}
							} catch (e) {
								console.warn('Failed to fetch material detail for Copy From:', e);
							}
						}
						// plant sudah SelectPrime → nilai tetap string kode (jangan di-wrap
						// jadi {label, value} object). Pastikan nilai tampil via fallback option.
						this.ensureOptionVisibleS('plantOptions', 'plant');
						// Location di Organization Level — pastikan ada opsi berlabel
						this.ensureOptionVisibleS('storageLocationOptions', 'ext_location');
					}
				}
				// Pastikan Copy From dropdowns punya opsi berlabel buat nilai tersimpan
				this.ensureCopyFromOptionS('copyFromPlantOptions', 'ext_cf_plant', this.secondary.optPlant);
				this.ensureCopyFromOptionS('copyFromLocationOptions', 'ext_cf_location', this.secondary.optStorageLoc);
				this.ensureCopyFromOptionS('copyFromValuationTypeOptions', 'ext_cf_valuation_type', this.secondary.optValuationType);
			} catch (error) {
				this.$toastNotifPrime('error', 'Error', 'Failed to fetch item data for editing');				} finally {
					this._skipResetDisabled = false;
					this.dialog.onLoading = false;
				}
			},

		closeDialog() {
			this.dialog.internalVisible = false;
			this.cancelPendingFiltersS();
			this.$emit('close');
		},

		onHide() {
			this.cancelPendingFiltersS();
			this.$emit('close');
		},
		// Batal timer pencarian Select (Equipment/UOM) yang masih pending (mis. saat
		// dialog ditutup) supaya tidak ada API call sia-sia setelah dialog hidden.
		cancelPendingFiltersS() {
			clearTimeout(this.equipmentFilterTimer);
			this.equipmentFilterTimer = null;
			clearTimeout(this.uomFilterTimer);
			this.uomFilterTimer = null;
			clearTimeout(this.materialTypeFilterTimer);
			this.materialTypeFilterTimer = null;
			clearTimeout(this.materialGroupFilterTimer);
			this.materialGroupFilterTimer = null;
			clearTimeout(this.valuationClassFilterTimer);
			this.valuationClassFilterTimer = null;
			clearTimeout(this.serviceGroupFilterTimer);
			this.serviceGroupFilterTimer = null;
			clearTimeout(this.plantFilterTimer);
			this.plantFilterTimer = null;
			clearTimeout(this.mrpTypeFilterTimer);
			this.mrpTypeFilterTimer = null;
			clearTimeout(this.lotSizeFilterTimer);
			this.lotSizeFilterTimer = null;
			clearTimeout(this.abcIndicatorFilterTimer);
			this.abcIndicatorFilterTimer = null;
			clearTimeout(this.storageLocationFilterTimer);
			this.storageLocationFilterTimer = null;
		},

		// === Internal form management ===
		resetForm() {
			this.dialog.validated = false;
			this.dialog.errors = {};
			this.dialog.isMaterialSelected = false;
			this.dialog.form = this.emptyRow();
			if (this.viewData && this.viewData.mcr_code) {
				this.dialog.form.mcr_code = this.viewData.mcr_code;
			}
			this.dialog.sections = { basic: true, attributes: true, mrp: true, attachments: true, notes: true, org: true, accounting: true };
			this.clearSuggestions();
		},
		clearSuggestions() {
			this.materialSuggestions = [];
			this.materialTypeOptions = [];
			this.materialTypeLoading = false;
			clearTimeout(this.materialTypeFilterTimer);
			this.materialTypeFilterTimer = null;
			this.materialTypeSearchedQueries = [];
			this.materialGroupOptions = [];
			this.materialGroupLoading = false;
			clearTimeout(this.materialGroupFilterTimer);
			this.materialGroupFilterTimer = null;
			this.materialGroupSearchedQueries = [];
			this.serviceGroupOptions = [];
			this.serviceGroupLoading = false;
			this.serviceGroupLoaded = false;
			clearTimeout(this.serviceGroupFilterTimer);
			this.serviceGroupFilterTimer = null;
			this.serviceGroupSearchedQueries = [];
			this.serviceCategoryOptions = [];
			this.plantOptions = [];
			this.plantLoading = false;
			clearTimeout(this.plantFilterTimer);
			this.plantFilterTimer = null;
			this.plantSearchedQueries = [];
			this.uomOptions = [];
			clearTimeout(this.uomFilterTimer);
			this.uomSearchedQueries = [];
			this.uomLoading = false;
			this.equipmentOptions = [];
			clearTimeout(this.equipmentFilterTimer);
			this.equipmentSearchedQueries = [];
			this.equipmentLoading = false;
			this.storageLocationOptions = [];
			this.storageLocationLoading = false;
			clearTimeout(this.storageLocationFilterTimer);
			this.storageLocationFilterTimer = null;
			this.storageLocationSearchedQueries = [];
			this.lotSizeOptions = [];
			this.lotSizeLoading = false;
			clearTimeout(this.lotSizeFilterTimer);
			this.lotSizeFilterTimer = null;
			this.lotSizeSearchedQueries = [];
			this.abcIndicatorOptions = [];
			this.abcIndicatorLoading = false;
			clearTimeout(this.abcIndicatorFilterTimer);
			this.abcIndicatorFilterTimer = null;
			this.abcIndicatorSearchedQueries = [];
			this.sparePartCategoryOptions = [];
			this.valuationClassOptions = [];
			this.valuationClassLoading = false;
			clearTimeout(this.valuationClassFilterTimer);
			this.valuationClassFilterTimer = null;
			this.valuationClassSearchedQueries = [];
			this.mrpTypeOptions = [];
			this.mrpTypeLoading = false;
			clearTimeout(this.mrpTypeFilterTimer);
			this.mrpTypeFilterTimer = null;
			this.mrpTypeSearchedQueries = [];
			this.standardDescriptionOptions = [];
			this.standardDescriptionLoading = false;
			this.manufacturerOptions = [];
			this.manufacturerLoading = false;
			this.manufacturerFilterTimer = null;
			this.manufacturerSearchedQueries = [];
			this.storageLocationOptions = [];
			this.valuationTypeOptions = [];
			this.priceControlOptions = [];
			this.materialDetail = null;
			this.copyFromPlantOptions = [];
			this.copyFromLocationOptions = [];
			this.copyFromValuationTypeOptions = [];
		},

		// Mapping AutoComplete fields to their API resource names
		autocompleteFieldsMap() {
			return {
				// mrp_type/lot_size/abc_indicator/service_group sudah SelectPrime (bukan
				// AutoComplete) → jangan di-resolve/wrap jadi {label, value}, nanti nilai
				// Select malah tidak match option-value.
				service_category: 'service-categories',
				valuation_type: 'valuation-types',
			};
		},

		async resolveAutoCompleteDefaults(fieldNames = null) {
			const map = this.autocompleteFieldsMap();
			const promises = [];

			// Bila fieldNames diberikan, resolve hanya field-field itu; default resolve semua
			// field di map (perilaku lama, dipakai openForAdd/openForEdit/openForLocalEdit).
			const keys = fieldNames && fieldNames.length
				? Object.keys(map).filter(k => fieldNames.includes(k))
				: Object.keys(map);

			keys.forEach(fieldName => {
				const value = this.dialog.form[fieldName];
				// Only resolve if it's a plain string (not already { label, value } object)
				if (value && typeof value === 'string' && value.length >= 2) {
					promises.push(
						(async () => {
							try {
								const resource = map[fieldName];
								const res = await api(this, generalMasterDataService.list(resource, {
									search: value,
									limit: 10,
									client: this.clientCode
								}), false);
								const items = Array.isArray(res.data?.data) ? res.data.data : (Array.isArray(res.data) ? res.data : []);
								// Cari item yang cocok: berdasarkan code, description, atau label format
								const match = items.find(item =>
									item.code === value ||
									item.description === value ||
									`${item.code} - ${item.description}` === value
								);
								if (match) {
									this.dialog.form[fieldName] = {
										label: `${match.code} - ${match.description}`,
										value: match.code,
										// Ikutkan account_category_ref (khusus material-type) supaya filter
										// acc_cat_ref Valuation Class tetap jalan saat edit mode.
										...(match.account_category_ref != null ? { account_category_ref: match.account_category_ref } : {}),
									};
									// Update mrpDefaults with resolved code for accurate comparison
									if (fieldName in this.mrpDefaults) {
										this.mrpDefaults[fieldName] = match.code;
									}
								}
							} catch (e) {
								console.warn(`Failed to resolve default for ${fieldName}:`, e);
							}
						})()
					);
				}
			});

			await Promise.all(promises);
		},

		emptyCopyFrom() {
			return {
				ext_cf_plant: '',
				ext_cf_location: '',
				ext_cf_valuation_type: '',
				ext_cf_sales_org: '',
				ext_cf_dist_channel: '',
				ext_cf_warehouse_number: '',
				ext_cf_storage_type: ''
			};
		},

		getFieldLabelS(value) {
			return typeof value === 'object' ? (value?.label || value?.value || '') : (value || '');
		},
		// Map config field name ke form field name untuk organizational_data
		orgFormFieldNameS(fieldName) {
			const aliasMap = {
				'plant': 'ext_plant',
				'location': 'ext_location',
				'valuation_type': 'ext_valuation_type',
				'sales_org': 'ext_sales_org',
				'distribution_channel': 'ext_dist_channel',
				'warehouse_no': 'ext_warehouse_number',
				'storage_type': 'ext_storage_type',
			};
			return aliasMap[fieldName] || fieldName;
		},
		getFilteredStorageLocation(plant) {
			if (!plant) return this.secondary.optStorageLoc;
			const filtered = this.secondary.optStorageLoc.filter(i => i.plant === plant);
			return filtered.length ? filtered : this.secondary.optStorageLoc;
		},

		async loadOptions() {
			if (this.secondary.optPlant.length) return;
			try {
				const { getMcrOptions } = await import('@/services/materialCatalogingRequest/mcrOptionsCache');
				const opts = await getMcrOptions();
				this.secondary.optPlant = opts.optPlant || [];
				if (!this.secondary.optValuationType.length) {
					this.secondary.optValuationType = opts.optValuationType || [];
				}
				this.secondary.optStorageLoc = opts.optStorageLoc || [];
			} catch (e) {
				console.error('Failed to load options:', e);
			}
		},

		configFieldNamesS(tab) {
			const tabKey = formConfigHelper.resolveTabKey(this.formConfig, tab);
			const fields = this.formConfig?.tab_fields?.[tabKey];
			return fields ? Object.keys(fields) : [];
		},

		isTabVisibleS(tabName) {
			if (!this.formConfig) return true;
			return formConfigHelper.isTabVisible(this.formConfig, tabName);
		},
		isFieldMandatoryS(tab, field) {
			return formConfigHelper.isFieldMandatory(this.formConfig, tab, field, this.formConfigCtxS);
		},
		isFieldEnabledS(tab, field) {
			return formConfigHelper.isFieldEnabled(this.formConfig, tab, field, this.formConfigCtxS);
		},
		isFieldVisibleS(tab, field) {
			return formConfigHelper.isFieldVisible(this.formConfig, tab, field, this.formConfigCtxS);
		},
		// Price Unit bisa dikirim config dengan nama price_unit, unit_price (MCR007/MassUpdateMrpForm),
		// atau cat_price_unit (form cataloguer) — terima semua alias supaya MCR001 tetap menampilkan field.
		isPriceUnitFieldVisibleS() {
			return ['price_unit', 'unit_price', 'cat_price_unit'].some(k => this.isFieldVisibleS('Basic Data & Specification', k));
		},
		isPriceUnitMandatoryS() {
			return ['price_unit', 'unit_price', 'cat_price_unit'].some(k => this.isFieldMandatoryS('Basic Data & Specification', k));
		},
		isSectionMandatoryS(tab) {
			return formConfigHelper.isSectionMandatory(this.formConfig, tab, this.formConfigCtxS);
		},
		isSectionEnabledS(tab, sectionName) {
			if (!this.formConfig) return true;
			return formConfigHelper.isSectionEnabled(this.formConfig, tab, sectionName, this.formConfigCtxS);
		},
		isSectionReadonlyS(tab, sectionName) {
			if (!this.formConfig) return true;
			return formConfigHelper.isSectionReadonly(this.formConfig, tab, sectionName);
		},

		applyConfigDefaultsS() {
			if (!this.formConfig?.tab_fields) return;
			const mrpFieldNames = this.configFieldNamesS('MRP');
			this.mrpDefaults = {};
			Object.keys(this.formConfig.tab_fields).forEach(tabName => {
				const fields = this.formConfig.tab_fields[tabName];
				Object.keys(fields).forEach(fieldName => {
					const fc = fields[fieldName];
					if (fc.default !== undefined && fc.default !== null) {
						if (mrpFieldNames.includes(fieldName)) {
							this.mrpDefaults[fieldName] = fc.default;
						}
						// Alias Price Unit: config bisa pakai unit_price / cat_price_unit → form dialog pakai price_unit
						const formKey = (fieldName === 'unit_price' || fieldName === 'cat_price_unit') ? 'price_unit' : fieldName;
						if (formKey in this.dialog.form && (this.dialog.form[formKey] === '' || this.dialog.form[formKey] === null)) {
							this.dialog.form[formKey] = fc.default;
						}
					}
				});
			});
		},

		resetDisabledFieldsS() {
			if (!this.formConfig?.tab_fields) return;
			Object.keys(this.formConfig.tab_fields).forEach(tabKey => {
				const fields = this.formConfig.tab_fields[tabKey];
				Object.keys(fields).forEach(fieldName => {
					if (!(fieldName in this.dialog.form)) return;
					if (!fields[fieldName].is_enabled || typeof fields[fieldName].is_enabled !== 'object') return;
					if (!this.isFieldEnabledS(tabKey, fieldName)) {
						const def = fields[fieldName].default;
						this.dialog.form[fieldName] = def !== undefined ? def : null;
					}
				});
			});
		},

		toggleSection(key) {
			this.dialog.sections[key] = !this.dialog.sections[key];
		},

		// === Manufacturer Parts ===
		addManuPartRow() {
			this.dialog.form.manufacturerParts.push({ manufacture: '', manufacture_ref: '', notes: '' });
		},
		deleteManuPartRow(index) {
			this.confirmDialog("You won't be able to revert this!", "delete it").then((result) => {
				if (result.isConfirmed) {
					this.dialog.form.manufacturerParts.splice(index, 1);
				}
			});
		},

		// === Attachments ===
		openAttachmentPicker() {
			this.$refs.attachmentInput && this.$refs.attachmentInput.click();
		},
		onAttachmentSelected(event) {
			const files = Array.from(event.target.files || []);
			const allowedTypes = [
				'image/png', 'image/jpeg', 'image/jpg', 'application/pdf',
				// Excel
				'application/vnd.ms-excel', // .xls
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
				// Word
				'application/msword', // .doc
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
			];
			// Fallback via ekstensi — MIME Office kadang tidak konsisten antar browser (terutama di Windows)
			const allowedExtensions = ['png', 'jpg', 'jpeg', 'pdf', 'xls', 'xlsx', 'doc', 'docx'];
			const validFiles = [];

			files.forEach((file) => {
				const ext = this.getFileExtensionS(file.name);
				if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(ext)) {
					this.$toastNotifPrime('error', 'Invalid File Type', `${file.name}: only PNG, JPG, PDF, Excel, and Word are allowed`);
					return;
				}
				if (file.size > this.maxValidation.size) {
					this.$toastNotifPrime('error', 'File Too Large', `${file.name}: exceeds ${this.maxValidation.text}`);
					return;
				}
				validFiles.push(file);
			});

			if (validFiles.length > 0) {
				this.dialog.form.attachments.push(...validFiles);
			}
			this.$refs.attachmentInput.value = '';
		},
		async downloadAttachment(file) {
			if (file.file_attachment_id) {
				try {
					const response = await api(this, smartcatAttachmentService.file(file.file_attachment_id), false);
					const blob = response.data instanceof Blob ? response.data : (response instanceof Blob ? response : new Blob([response?.data || '']));
					const url = URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = file.name || 'attachment';
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					setTimeout(() => URL.revokeObjectURL(url), 100);
				} catch {
					this.$toastNotifPrime('error', 'Error', 'Failed to download file');
				}
			} else if (file instanceof File) {
				const url = URL.createObjectURL(file);
				const a = document.createElement('a');
				a.href = url;
				a.download = file.name;
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				setTimeout(() => URL.revokeObjectURL(url), 100);
			}
		},
		getFileExtensionS(name) {
			return name ? name.split('.').pop().toLowerCase() : '';
		},
		isImageFileS(file) {
			const ext = this.getFileExtensionS(file?.name);
			const mime = (file?.mime_type || '').toLowerCase();
			return mime.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(ext);
		},
		isPdfFileS(file) {
			const ext = this.getFileExtensionS(file?.name);
			const mime = (file?.mime_type || '').toLowerCase();
			return mime === 'application/pdf' || ext === 'pdf';
		},
		isPreviewableS(file) {
			if (file instanceof File) {
				return file.type.startsWith('image/') || file.type === 'application/pdf';
			}
			return !!file.file_attachment_id && (this.isImageFileS(file) || this.isPdfFileS(file));
		},
		async previewAttachmentS(file) {
			if (file instanceof File) {
				const url = URL.createObjectURL(file);
				if (file.type === 'application/pdf') {
					this.previewModal.pdfUrl = url;
					this.previewModal.title = file.name;
					this.previewModal.visible = true;
				} else if (file.type.startsWith('image/')) {
					this.openImagePreviewS(url);
				}
				return;
			}
			if (!file.file_attachment_id) return;
			try {
				const response = await api(this, smartcatAttachmentService.file(file.file_attachment_id), false);
				const raw = response.data instanceof Blob ? response.data : (response instanceof Blob ? response : new Blob([response?.data || '']));
				if (this.isPdfFileS(file)) {
					const blob = new Blob([raw], { type: 'application/pdf' });
					this.previewModal.pdfUrl = URL.createObjectURL(blob);
					this.previewModal.title = file.name || 'Preview';
					this.previewModal.visible = true;
				} else if (this.isImageFileS(file)) {
					this.openImagePreviewS(URL.createObjectURL(raw));
				}
			} catch (e) {
				this.$toastNotifPrime('error', 'Error', 'Failed to load preview');
			}
		},
		openImagePreviewS(url) {
			if (this.previewModal.imageUrl && this.previewModal.imageUrl.startsWith('blob:')) {
				URL.revokeObjectURL(this.previewModal.imageUrl);
			}
			this.previewModal.imageUrl = url;
		},
		onPreviewImageLoadS() {
			if (this.previewModal.imageUrl && this.previewModal.imageUrl.startsWith('blob:')) {
				this.$nextTick(() => {
					if (this.$refs.imagePreviewer && typeof this.$refs.imagePreviewer.onImageClick === 'function') {
						this.$refs.imagePreviewer.onImageClick();
					}
				});
			}
		},
		deleteAttachmentRow(index) {
			this.confirmDialog("You won't be able to revert this!", "delete it").then((result) => {
				if (result.isConfirmed) {
					this.dialog.form.attachments.splice(index, 1);
				}
			});
		},

		// === Search methods ===
		async searchMaterial(event) {
			if (!event.query || event.query.length < 2) { this.materialSuggestions = []; return; }
			this.dialog.isMaterialSelected = false;
			this.materialLoading = true;
			try {
				// MCR service (MCR008/MCR009): cari via Advance Search Service, value = service_number
				if (this.isService) {
					await this.searchServiceSuggestions(event.query);
					return;
				}
				const res = await api(this, euMaterialService.list({ search: event.query, limit: 20, company: this.companyCode }), false);
				const data = res.data?.data?.data || res.data?.data || [];
				this.materialSuggestions = data.map(i => ({
					label: materialNumberFormatter.formatMaterialNumber(i.material_number),
					value: materialNumberFormatter.formatMaterialNumber(i.material_number),
					raw: i.material_number,
					inc: i.inc,
					short_text: i.short_text
				}));
			} catch {
				this.materialSuggestions = [];
			} finally {
				this.materialLoading = false;
			}
		},
		// Search service (MCR008/MCR009) via POST navbar/advance-search-service/search
		async searchServiceSuggestions(query) {
			this.materialSuggestions = [];
			try {
				// Body lengkap 9 field sesuai kontrak API (hanya `service` yang diisi untuk autocomplete)
				const payload = {
					service: query || '',
					item_name: '',
					mcr_number: '',
					service_category: '',
					service_group: '',
					uom: '',
					valuation_class: '',
					group_class: '',
					created_at: '',
				};
				const res = await api(this, serviceAdvanceService.search(payload), false);
				// api() mengembalikan body { status, message, data: { total, rows } },
				// jadi meta ada di res.data (fallback chain utk bentuk response lain).
				const meta = res?.data?.data || res?.data || {};
				const rows = meta?.rows || [];
				this.materialSuggestions = rows.map(r => {
					const s = r?._source || r || {};
					return {
						label: s.service_number || '',
						value: s.service_number || '',
						short_text: s.short_text || '',
					};
				});
			} catch {
				this.materialSuggestions = [];
			}
		},
		onMaterialClear() {
			this.dialog.isMaterialSelected = false;
			this.materialSuggestions = [];
			this.materialDetail = null;
			this.dialog.form.material_number_raw = '';
			// Currency ikut di-reset supaya tidak nyangkut dari material/service sebelumnya.
			this.dialog.form.currency = '';
			this.valuationTypeOptions = [];
			this.copyFromPlantOptions = [];
			this.copyFromLocationOptions = [];
			this.copyFromValuationTypeOptions = [];
			this.dialog.copyFrom = this.emptyCopyFrom();
		},
		async onMaterialNumberSelect(e) {
			const selectedValue = typeof e.value === 'object' ? (e.value.value ?? e.value) : e.value;
			const suggestion = this.materialSuggestions.find(s => s.value === selectedValue);
			const raw = suggestion?.raw || selectedValue;
			this.dialog.form.material_number = selectedValue; // formatted (tampilan)
			this.dialog.form.material_number_raw = raw;       // raw (untuk API)
			this.dialog.isMaterialSelected = false;
			if (raw) {
				if (this.isService) {
					// Service: panggil GET detail service untuk populate field (mirip alur material)
					await this.fetchServiceDetailS(raw);
				} else {
					await this.fetchMaterialDetailS(raw);
				}
			}
		},
		async fetchMaterialDetailS(materialNumber) {
			this.dialog.onLoading = true;
			this.materialLoading = true;
			try {
				const res = await api(this, advanceSearchService.getMaterialDetail(materialNumber), false);
				const detail = res?.data?.data || res?.data || null;
				if (!detail) {
					// Mode edit item yang sudah punya material_number: jangan nonaktifkan field
					// (mis. detail API gagal/transient) — biarkan tetap unlock. Mode add baru
					// (editingItemId null) tetap dianggap belum terpilih.
					if (!this.dialog.editingItemId) this.dialog.isMaterialSelected = false;
					return;
				}
				if (detail.material_type) {
					// Select butuh nilai kode (string) — handle semua bentuk (object/string),
					// pastikan opsi-nya ada di daftar (ikutkan account_category_ref supaya
					// filter acc_cat_ref Valuation Class jalan).
					const mt = detail.material_type;
					const isObj = typeof mt === 'object' && mt !== null;
					const code = String(isObj ? (mt.code ?? mt.value ?? '') : mt);
					const label = isObj ? (mt.label || `${mt.code} - ${mt.description}`) : mt;
					this.dialog.form.material_type = code;
					this.ensureOptionVisibleS('materialTypeOptions', 'material_type', label, {
						...(isObj && mt.account_category_ref != null ? { account_category_ref: mt.account_category_ref } : {}),
					});
				}
				if (detail.material_group) {
					const mg = detail.material_group;
					const isObj = typeof mg === 'object' && mg !== null;
					const code = String(isObj ? (mg.code ?? mg.value ?? '') : mg);
					const label = isObj ? (mg.label || `${mg.code} - ${mg.description}`) : mg;
					this.dialog.form.material_group = code;
					this.ensureOptionVisibleS('materialGroupOptions', 'material_group', label);
				}
				if (detail.uom_data) {
					// Select UOM butuh nilai kode (string), bukan objek {label, value} —
					// pastikan opsi-nya ada di daftar supaya nilai tetap tampil terpilih.
					const code = String(detail.uom_data.code);
					this.dialog.form.uom = code;
					this.ensureOptionVisibleS('uomOptions', 'uom', this.masterDataOptionLabelS(detail.uom_data));
				} else if (detail.uom) {
					this.dialog.form.uom = detail.uom;
					this.ensureOptionVisibleS('uomOptions', 'uom');
				}
				this.applyCurrencyFromDetailS(detail.currency);
				const firstPlant = Array.isArray(detail.eu_material_plant) && detail.eu_material_plant.length
					? detail.eu_material_plant[0].plant : '';
				if (firstPlant) {
					this.dialog.form.plant = firstPlant;
				}
				const valuation = Array.isArray(detail.eu_material_valuation) && detail.eu_material_valuation.length
					? detail.eu_material_valuation[0] : null;
				if (valuation) {
					const price = valuation.price_reference ?? valuation.std_price;
					this.dialog.form.price_reference = price != null ? Number(price) : null;
					// Also populate Accounting tab fields from valuation data
					if (valuation.valuation_class) {
						this.dialog.form.valuation_class = String(valuation.valuation_class);
						this.ensureOptionVisibleS('valuationClassOptions', 'valuation_class');
					}
					if (valuation.price_control) {
						this.dialog.form.price_control = valuation.price_control;
					}
					if (valuation.std_price != null && valuation.std_price !== '') {
						this.dialog.form.standard_price = Number(valuation.std_price);
					}
				}
				if (detail.short_text) {
					let spec = detail.short_text;
					// TIMAH: append po_text_vertical ke specification
					if (this.companyCode === 'TIMAH' && detail.po_text_vertical) {
						const poText = detail.po_text_vertical.replace(/^\n+|\n+$/g, '').replace(/\n{3,}/g, '\n\n');
						spec = spec ? `${spec}\n\n${poText}` : poText;
					}
					this.dialog.form.specification = spec;
				}
				if (Array.isArray(detail.eu_material_manufacturer) && detail.eu_material_manufacturer.length) {
					this.dialog.form.manufacturerParts = detail.eu_material_manufacturer.map(m => ({
						manufacture: m.manufacture || '',
						manufacture_ref: m.manufacture_ref || '',
						notes: m.notes || '',
					}));
				}
				this.materialDetail = detail;
				this.populateCopyFromOptionsS(detail.eu_material_plant, detail.eu_material_location, detail.eu_material_valuation);
				this.ensureOptionVisibleS('plantOptions', 'plant');
				this.dialog.isMaterialSelected = true;
				// Setelah material terpilih, load dropdown options supaya codes → labels.
				// loadingKey guard mencegah double-load (sudah di-load sebelumnya).
				await Promise.all([
					this.loadMaterialTypeOptions(),
					this.loadMaterialGroupOptions(),
					this.loadPlantOptions(),
					this.loadUomOptions(),
					this.loadValuationClassOptions(),
					this.loadEquipmentOptions(),
					this.loadManufacturerOptions(),
				]);
				// Pastikan nilai tersimpan tetap tampil berlabel setelah options di-load.
				this.ensureOptionVisibleS('materialTypeOptions', 'material_type');
				this.ensureOptionVisibleS('materialGroupOptions', 'material_group');
				this.ensureOptionVisibleS('plantOptions', 'plant');
				this.ensureOptionVisibleS('uomOptions', 'uom');
				this.ensureOptionVisibleS('valuationClassOptions', 'valuation_class');
				this.ensureOptionVisibleS('equipmentOptions', 'equipment');
				// Manufacturer ada di manufacturerParts (array) — pastikan setiap kode punya opsi berlabel.
				this.dialog.form.manufacturerParts.forEach(p => {
					if (p.manufacture && !this.manufacturerOptions.some(o => String(o.value) === String(p.manufacture))) {
						this.manufacturerOptions.unshift({ label: String(p.manufacture), value: String(p.manufacture) });
					}
				});
			} catch (error) {
				if (!this.dialog.editingItemId) this.dialog.isMaterialSelected = false;
				this.$toastNotifPrime('error', 'Error', 'Failed to fetch material detail');
			} finally {
				this.dialog.onLoading = false;
				this.materialLoading = false;
			}
		},
		// Populate opsi dropdown Copy From (Organization Level) dari rows plant/location/valuation.
		// Dipakai saat fetch detail material (alur add/pilih) & saat edit (dari data item yang
		// tersimpan, tanpa fetch ulang) supaya field Copy From tetap aktif & terisi.
		populateCopyFromOptionsS(plantRows, locationRows, valuationRows) {
			// Helper: resolve label dari master data cache (secondary.optXxx)
			const resolveLabel = (code, cache, fallback) => {
				if (!code) return fallback || '';
				const match = (cache || []).find(o => String(o.code) === String(code));
				return match ? match.label : (fallback || code);
			};

			const plantMap = new Map();
			(plantRows || []).forEach(p => {
				if (p?.plant && !plantMap.has(p.plant)) {
					plantMap.set(p.plant, {
						label: resolveLabel(p.plant, this.secondary.optPlant, p.plant),
						value: p.plant
					});
				}
			});
			this.copyFromPlantOptions = Array.from(plantMap.values());

			const locationMap = new Map();
			(locationRows || []).forEach(l => {
				const locCode = l?.storage_location?.code || l?.location || '';
				if (locCode && !locationMap.has(locCode)) {
					const fallback = l?.storage_location?.label || l?.location || locCode;
					locationMap.set(locCode, {
						label: resolveLabel(locCode, this.secondary.optStorageLoc, fallback),
						value: locCode,
						plant: l?.plant
					});
				}
			});
			this.copyFromLocationOptions = Array.from(locationMap.values());

			// Pre-populate Copy From Valuation Type options from material valuation data (deduplicated)
			const valuationTypeMap = new Map();
			(valuationRows || []).forEach(v => {
				if (v?.valuation_type && !valuationTypeMap.has(v.valuation_type)) {
					valuationTypeMap.set(v.valuation_type, {
						label: resolveLabel(v.valuation_type, this.secondary.optValuationType, v.valuation_type),
						value: v.valuation_type
					});
				}
			});
			this.copyFromValuationTypeOptions = Array.from(valuationTypeMap.values());
		},
		// Fetch detail service (MCR008/MCR009) via GET navbar/advance-search-service/{service_number}
		async fetchServiceDetailS(serviceNumber) {
			this.dialog.onLoading = true;
			this.materialLoading = true;
			try {
				const res = await api(this, serviceAdvanceService.getServiceDetail(serviceNumber), false);
				const detail = res?.data?.data || res?.data || null;
				if (!detail) {
					// Mode edit: item sudah punya service_number → jangan nonaktifkan field
					if (!this.dialog.editingItemId) this.dialog.isMaterialSelected = false;
					return;
				}
				// service_category TIDAK diisi (config MCR009 menguncinya, default "MIND")
				// Set nilai sebagai string dulu, lalu resolve ke master data supaya label-nya
				// ngefit (format "CODE - description") — sama seperti alur material.
				if (detail.service_group) this.dialog.form.service_group = detail.service_group;
				if (detail.uom) {
					this.dialog.form.uom = detail.uom;
					this.ensureOptionVisibleS('uomOptions', 'uom');
				}
				if (detail.valuation_class) {
					this.dialog.form.valuation_class = String(detail.valuation_class);
					this.ensureOptionVisibleS('valuationClassOptions', 'valuation_class');
				}
				if (detail.short_text) this.dialog.form.specification = detail.short_text;
				if (detail.notes) this.dialog.form.notes = detail.notes;
				this.applyCurrencyFromDetailS(detail.currency);
				this.materialDetail = detail;
				this.dialog.isMaterialSelected = true;
				// Setelah service terpilih, load dropdown options supaya codes → labels.
				await Promise.all([
					this.loadServiceGroupOptions(),
					this.loadUomOptions(),
					this.loadValuationClassOptions(),
				]);
				// Pastikan nilai tersimpan tetap tampil berlabel setelah options di-load.
				this.ensureOptionVisibleS('serviceGroupOptions', 'service_group');
				this.ensureOptionVisibleS('uomOptions', 'uom');
				this.ensureOptionVisibleS('valuationClassOptions', 'valuation_class');
			} catch (error) {
				if (!this.dialog.editingItemId) this.dialog.isMaterialSelected = false;
				this.$toastNotifPrime('error', 'Error', 'Failed to fetch service detail');
			} finally {
				this.dialog.onLoading = false;
				this.materialLoading = false;
			}
		},
		// uom, valuation_class & service_group kini Select (bukan AutoComplete) → tidak
		// perlu resolve/wrap label {label, value} lagi. Service category (AutoComplete)
		// dibiarkan apa adanya (bisa dikunci config MCR009).
		async resolveServiceDetailMasterDataS() {
			// Tidak ada field AutoComplete yang perlu di-resolve dari detail service.
		},
		// Isi currency dari detail material/service (normalisasi uppercase), lalu pastikan
		// opsi Dropdown Currency memuat nilai tersebut (bila bukan IDR/USD) supaya tampil
		// & terpilih, bukan hanya tersimpan di form.
		applyCurrencyFromDetailS(currency) {
			if (!currency) return;
			const normalized = String(currency).toUpperCase();
			this.dialog.form.currency = normalized;
			// Tambahkan ke extraCurrencyOptions jika belum ada di base config maupun extra
			if (!this.extraCurrencyOptions.some(o => o.value === normalized)) {
				const config = formConfigHelper.getFieldConfig(this.formConfig, 'Basic Data & Specification', 'currency');
				const inConfig = Array.isArray(config?.options) && config.options.some(o => o.value === normalized);
				if (!inConfig) {
					this.extraCurrencyOptions = [{ label: normalized, value: normalized }, ...this.extraCurrencyOptions];
				}
			}
		},
		// AutoComplete master data generic: API hanya dipanggil setelah minimal 2 karakter.
		async searchMasterData(resource, optionsKey, event, { filter, mapper, params } = {}) {
			// Query kosong (klik tombol dropdown AutoComplete): jangan kosongkan opsi —
			// biarkan opsi yang sudah dimuat tetap tampil; panel dibuka oleh handler
			// @dropdown-click masing-masing field.
			if (!event.query || event.query.length < 2) return;
			try {
				const res = await api(this, generalMasterDataService.list(resource, { search: event.query, limit: 10, client: this.clientCode, ...params }), false);
				const items = Array.isArray(res.data?.data) ? res.data.data : (Array.isArray(res.data) ? res.data : []);
				const list = filter ? items.filter(filter) : items;
				this[optionsKey] = list.map(mapper || (m => ({ label: `${m.code} - ${m.description}`, value: m.code })));
			} catch { this[optionsKey] = []; }
		},
		// === Select Master Data (pola UOM): lazy load 10 opsi saat dropdown diklik ===
		// Material Type — buang kode HERS & simpan account_category_ref (dipakai sebagai
		// filter acc_cat_ref Valuation Class). Load sekali per sesi dialog.
		async loadMaterialTypeOptions(forceAll, resolveOnly) {
			await this.loadMasterDataSelectS('material-type', 'material_type', 'materialTypeOptions', m => this.masterDataOptionLabelS(m), { limit: 10 }, {
				itemFilter: m => m.code !== 'HERS',
				itemMapper: m => ({ label: this.masterDataOptionLabelS(m), value: String(m.code), account_category_ref: m.account_category_ref || null }),
				forceAll, resolveOnly,
			});
		},
		async onMaterialTypeShow() {
			if (this.materialTypeLoading) return;
			this.materialTypeLoading = true;
			try {
				await this.loadMaterialTypeOptions(true);
			} finally {
				this.materialTypeLoading = false;
			}
		},
		onMaterialTypeFilter({ value }) {
			return this.onMasterDataSelectFilter('material-type', 'materialTypeOptions', 'materialTypeSearchedQueries', 'materialTypeFilterTimer', value, {
				filter: m => m.code !== 'HERS',
				mapper: m => ({ label: this.masterDataOptionLabelS(m), value: String(m.code), account_category_ref: m.account_category_ref || null }),
			});
		},
		async loadMaterialGroupOptions(forceAll, resolveOnly) {
			await this.loadMasterDataSelectS('material-group', 'material_group', 'materialGroupOptions', m => this.masterDataOptionLabelS(m), { limit: 10 }, { forceAll, resolveOnly });
		},
		async onMaterialGroupShow() {
			if (this.materialGroupLoading) return;
			this.materialGroupLoading = true;
			try {
				await this.loadMaterialGroupOptions(true);
			} finally {
				this.materialGroupLoading = false;
			}
		},
		onMaterialGroupFilter({ value }) {
			return this.onMasterDataSelectFilter('material-group', 'materialGroupOptions', 'materialGroupSearchedQueries', 'materialGroupFilterTimer', value);
		},
		async loadValuationClassOptions(forceAll, resolveOnly) {
			const accCatRef = this.getValuationAccCatRefS();
			await this.loadMasterDataSelectS('valuation-classes', 'valuation_class', 'valuationClassOptions', m => this.masterDataOptionLabelS(m), {
				limit: 10,
				...(accCatRef ? { acc_cat_ref: accCatRef } : {}),
			}, { forceAll, resolveOnly });
		},
		async onValuationClassShow() {
			if (this.valuationClassLoading) return;
			this.valuationClassLoading = true;
			try {
				await this.loadValuationClassOptions(true);
			} finally {
				this.valuationClassLoading = false;
			}
		},
		onValuationClassFilter({ value }) {
			const accCatRef = this.getValuationAccCatRefS();
			return this.onMasterDataSelectFilter('valuation-classes', 'valuationClassOptions', 'valuationClassSearchedQueries', 'valuationClassFilterTimer', value, {
				params: accCatRef ? { acc_cat_ref: accCatRef } : undefined,
			});
		},
		// Filter search Select (pola UOM): cek dulu di opsi lokal; kalau tidak ketemu →
		// panggil API search (debounce 400ms, anti query duplikat) & merge hasil ke opsi.
		onMasterDataSelectFilter(resource, optionsKey, searchedState, timerState, value, { filter, mapper, params, service } = {}) {
			const q = (value || '').trim();
			if (q.length < 2) return;
			const key = q.toLowerCase();
			if (this[searchedState].includes(key)) return;
			const hasLocalMatch = this[optionsKey].some(o => String(o.label || '').toLowerCase().includes(key));
			if (hasLocalMatch) return;
			this[searchedState].push(key);
			clearTimeout(this[timerState]);
			// Nyalakan spinner (slot #emptyfilter) selama pencarian API berlangsung.
			// Nama flag ikut konvensi: <optionsKey> tanpa akhiran "Options" + "Loading".
			const loadingState = optionsKey.replace(/Options$/, 'Loading');
			if (loadingState in this) this[loadingState] = true;
			this[timerState] = setTimeout(async () => {
				try {
					const listFn = service || (p => generalMasterDataService.list(resource, p));
					const res = await api(this, listFn({ search: q, limit: 10, client: this.clientCode, ...params }), false);
					const data = Array.isArray(res) ? res : res?.data;
					const items = Array.isArray(data) ? data
						: (Array.isArray(data?.data) ? data.data
							: (Array.isArray(data?.data?.data) ? data.data.data : []));
					const existing = new Set(this[optionsKey].map(o => o.value));
					const fresh = items
						.filter(i => i && i.code !== undefined && i.code !== null)
						.filter(item => !filter || filter(item))
						.map(item => (mapper || (m => ({ label: this.masterDataOptionLabelS(m), value: String(m.code) })))(item))
						.filter(o => !existing.has(o.value));
					if (fresh.length) this[optionsKey] = [...this[optionsKey], ...fresh];
				} catch (e) {
					console.warn(`Failed to search ${resource}:`, e);
				} finally {
					if (loadingState in this) this[loadingState] = false;
				}
			}, 400);
		},
		// Service Group — lazy load saat dropdown diklik (sama pola UOM): 10 opsi
		// pertama + filter search API debounce 400ms.
		async onServiceGroupShow() {
			if (this.serviceGroupLoading) return;
			this.serviceGroupLoading = true;
			try {
				await this.loadServiceGroupOptions(true);
			} finally {
				this.serviceGroupLoading = false;
			}
		},
		async loadServiceGroupOptions(forceAll, resolveOnly) {
			await this.loadMasterDataSelectS('service-groups', 'service_group', 'serviceGroupOptions', m => this.masterDataOptionLabelS(m), { limit: 10 }, { forceAll, resolveOnly });
		},
		onServiceGroupFilter({ value }) {
			return this.onMasterDataSelectFilter('service-groups', 'serviceGroupOptions', 'serviceGroupSearchedQueries', 'serviceGroupFilterTimer', value);
		},
		searchServiceCategory(event) {
			return this.searchMasterData('service-categories', 'serviceCategoryOptions', event, {
				// Simpan account_category_ref supaya bisa dipakai sebagai filter acc_cat_ref
				// Valuation Class (diambil dari Service Category terpilih — MCR008 dkk).
				mapper: sc => ({ label: sc.label || `${sc.code} - ${sc.description}`, value: sc.code, account_category_ref: sc.account_category_ref || null }),
			});
		},
		// Plant — lazy load saat dropdown diklik (sama pola UOM): 10 opsi
		// pertama + filter search API debounce 400ms.
		async onPlantShow() {
			if (this.plantLoading) return;
			this.plantLoading = true;
			try {
				await this.loadPlantOptions(true);
			} finally {
				this.plantLoading = false;
			}
		},
		async loadPlantOptions(forceAll, resolveOnly) {
			await this.loadMasterDataSelectS('plant', 'plant', 'plantOptions', m => this.masterDataOptionLabelS(m), { limit: 10 }, { forceAll, resolveOnly });
		},
		onPlantFilter({ value }) {
			return this.onMasterDataSelectFilter('plant', 'plantOptions', 'plantSearchedQueries', 'plantFilterTimer', value);
		},
		// Lot Size — lazy load saat dropdown diklik (sama pola UOM): 10 opsi
		// pertama + filter search API debounce 400ms.
		async onLotSizeShow() {
			if (this.lotSizeLoading) return;
			this.lotSizeLoading = true;
			try {
				await this.loadLotSizeOptions(true);
			} finally {
				this.lotSizeLoading = false;
			}
		},
		async loadLotSizeOptions(forceAll, resolveOnly) {
			await this.loadMasterDataSelectS('lot-sizes', 'lot_size', 'lotSizeOptions', m => this.masterDataOptionLabelS(m), { limit: 10 }, { forceAll, resolveOnly });
		},
		onLotSizeFilter({ value }) {
			return this.onMasterDataSelectFilter('lot-sizes', 'lotSizeOptions', 'lotSizeSearchedQueries', 'lotSizeFilterTimer', value);
		},
		// Ambil account_category_ref untuk filter acc_cat_ref Valuation Class:
		// - MCR service (MCR008 dkk): dari Service Category yang dipilih
		// - Material: dari Material Type yang dipilih
		// Nilai bisa berupa object di form (hasil pilih) atau fallback dari cache opsi.
		getValuationAccCatRefS() {
			const source = this.isService ? this.dialog.form.service_category : this.dialog.form.material_type;
			const cache = this.isService ? this.serviceCategoryOptions : this.materialTypeOptions;
			if (source && typeof source === 'object') return source.account_category_ref || null;
			const match = cache.find(o => o.value === source);
			if (match?.account_category_ref) return match.account_category_ref;
			// Fallback: nilai yang disimpan saat openForEdit dari itemData langsung.
			return this.isService ? (this.dialog._editServiceCatAccCatRef || null) : (this.dialog._editAccCatRef || null);
		},
		// MRP Type — lazy load saat dropdown diklik (sama pola UOM): 10 opsi
		// pertama + filter search API debounce 400ms.
		async onMrpTypeShow() {
			if (this.mrpTypeLoading) return;
			this.mrpTypeLoading = true;
			try {
				await this.loadMrpTypeOptions(true);
			} finally {
				this.mrpTypeLoading = false;
			}
		},
		async loadMrpTypeOptions(forceAll, resolveOnly) {
			await this.loadMasterDataSelectS('mrp-types', 'mrp_type', 'mrpTypeOptions', m => this.masterDataOptionLabelS(m), { limit: 10 }, { forceAll, resolveOnly });
		},
		onMrpTypeFilter({ value }) {
			return this.onMasterDataSelectFilter('mrp-types', 'mrpTypeOptions', 'mrpTypeSearchedQueries', 'mrpTypeFilterTimer', value);
		},
		// ABC Indicator — lazy load saat dropdown diklik (sama pola UOM): 10 opsi
		// pertama + filter search API debounce 400ms.
		async onAbcIndicatorShow() {
			if (this.abcIndicatorLoading) return;
			this.abcIndicatorLoading = true;
			try {
				await this.loadAbcIndicatorOptions(true);
			} finally {
				this.abcIndicatorLoading = false;
			}
		},
		async loadAbcIndicatorOptions(forceAll, resolveOnly) {
			await this.loadMasterDataSelectS('abc-indicators', 'abc_indicator', 'abcIndicatorOptions', m => this.masterDataOptionLabelS(m), { limit: 10 }, { forceAll, resolveOnly });
		},
		onAbcIndicatorFilter({ value }) {
			return this.onMasterDataSelectFilter('abc-indicators', 'abcIndicatorOptions', 'abcIndicatorSearchedQueries', 'abcIndicatorFilterTimer', value);
		},
		searchValuationType(event) {
			return this.searchMasterData('valuation-types', 'valuationTypeOptions', event, { mapper: vt => ({ label: vt.label || `${vt.code} - ${vt.description}`, value: vt.code }) });
		},
		async searchStorageLocation(event) {
			if (!event.query || event.query.length < 2) { this.storageLocationOptions = []; return; }
			// Get selected plant value from the ext_plant field above
			const plantVal = this.getFieldLabelS(this.dialog.form.ext_plant);
			if (!plantVal) {
				this.storageLocationOptions = [];
				return;
			}
			const plantCode = plantVal.includes(' - ') ? plantVal.split(' - ')[0].trim() : plantVal.trim();
			try {
				const res = await api(this, generalMasterDataService.list('storage-location', { search: event.query, limit: 10, client: this.clientCode, plant_code: plantCode }), false);
				const items = res.data?.data || res.data || [];
				let mapped = (Array.isArray(items) ? items : []).map(sl => ({ label: sl.label || `${sl.code} - ${sl.description}`, value: sl.code, plant: sl.plant || '' }));
				// Client-side filter by plant as a fallback
				if (plantCode) {
					mapped = mapped.filter(sl => sl.plant === plantCode);
				}
				this.storageLocationOptions = mapped;
			} catch (e) {
				console.warn('Failed to load storage locations:', e);
				this.storageLocationOptions = [];
			}
		},			async loadStorageLocationOptions(forceAll, resolveOnly) {
			const plantVal = this.getFieldLabelS(this.dialog.form.ext_plant);
			const plantCode = plantVal ? (plantVal.includes(' - ') ? plantVal.split(' - ')[0].trim() : plantVal.trim()) : '';
			if (!plantCode) return;
			// Edit mode: search by current value. forceAll: load 10 awal. resolveOnly: hanya resolve label.
			const isEdit = Boolean(this.dialog.editingItemId);
			const currentVal = this.dialog.form.ext_location || '';
			const searchCode = (isEdit && !forceAll && currentVal) ? String(currentVal) : '';
			try {
				const res = await api(this, generalMasterDataService.list('storage-location', { search: searchCode, limit: 10, client: this.clientCode, plant_code: plantCode }), false);
				const items = res.data?.data || res.data || [];
				const mapped = (Array.isArray(items) ? items : [])
					.filter(sl => sl && sl.code !== undefined)
					.map(sl => ({ label: sl.label || `${sl.code} - ${sl.description}`, value: sl.code }));
				if (resolveOnly) {
					// Hanya resolve label ke form value, tidak populate options.
					this.resolveMasterDataSelectValueS(items, 'ext_location', 'storageLocationOptions', sl => sl.label || `${sl.code} - ${sl.description}`);
				} else {
					this.storageLocationOptions = mapped;
				}
			} catch {
				this.storageLocationOptions = [];
			}
		},
		onStorageLocationShow() {
			if (this.storageLocationLoading) return;
			this.storageLocationLoading = true;
			// Load storage location berdasarkan plant yang dipilih (tanpa search → load 10 awal)
			const plantVal = this.getFieldLabelS(this.dialog.form.ext_plant);
			const plantCode = plantVal ? (plantVal.includes(' - ') ? plantVal.split(' - ')[0].trim() : plantVal.trim()) : '';
			if (!plantCode) {
				this.storageLocationLoading = false;
				return;
			}
			generalMasterDataService.list('storage-location', { search: '', limit: 10, client: this.clientCode, plant_code: plantCode })
				.then(res => {
					const items = res.data?.data || res.data || [];
					this.storageLocationOptions = (Array.isArray(items) ? items : [])
						.filter(sl => sl && sl.code !== undefined)
						.map(sl => ({ label: sl.label || `${sl.code} - ${sl.description}`, value: sl.code }));
				})
				.catch(() => { /* pertahankan opsi yang sudah ada */ })
				.finally(() => {
					this.storageLocationLoading = false;
				});
		},
		onStorageLocationFilter({ value }) {
			return this.onMasterDataSelectFilter('storage-location', 'storageLocationOptions', 'storageLocationSearchedQueries', 'storageLocationFilterTimer', value, {
				params: { plant_code: this.getFieldLabelS(this.dialog.form.ext_plant)?.split?.(' - ')[0]?.trim() || '' },
			});
		},

		// Manufacturer (DataTable per-baris) — lazy load saat dropdown diklik,
		// sama pola seperti UOM: 10 opsi pertama + filter search API debounce.
		async onManufacturerShow() {
			if (this.manufacturerLoading) return;
			this.manufacturerLoading = true;
			try {
				await this.loadManufacturerOptions(true);
			} finally {
				this.manufacturerLoading = false;
			}
		},
		async loadManufacturerOptions(forceAll) {
			// Manufacturer ada di manufacturerParts (array), bukan form langsung.
			// Add mode: limit 10. Edit mode: search semua kode yang tersimpan.
			// forceAll: load 10 item pertama tanpa search (saat user klik dropdown).
			const isEdit = Boolean(this.dialog.editingItemId);
			let apiParams;
			if (isEdit && !forceAll) {
				const codes = (this.dialog.form.manufacturerParts || [])
					.map(p => p.manufacture).filter(Boolean).join(' ');
				apiParams = { limit: 10, client: this.clientCode, search: codes };
			} else {
				apiParams = { limit: 10, client: this.clientCode };
			}
			try {
				const res = await api(this, manufacturerService.list(apiParams), false);
				const data = Array.isArray(res) ? res : res?.data;
				const items = Array.isArray(data) ? data
					: (Array.isArray(data?.data) ? data.data
						: (Array.isArray(data?.data?.data) ? data.data.data : []));
				this.manufacturerOptions = items
					.filter(m => m && m.code !== undefined && m.code !== null)
					.map(m => ({ label: m.label || `${m.code} - ${m.name || ''}`, value: String(m.code) }));
			} catch (e) {
				console.warn('Failed to load manufacturer:', e);
				// Jangan clear options saat API error — pertahankan opsi yang sudah ada
			}
		},
		onManufacturerFilter({ value }) {
			return this.onMasterDataSelectFilter('manufacturer', 'manufacturerOptions', 'manufacturerSearchedQueries', 'manufacturerFilterTimer', value, {
				service: p => manufacturerService.list(p),
				mapper: m => ({ label: m.label || `${m.code} - ${m.name || ''}`, value: String(m.code) }),
			});
		},
		// Muat opsi dropdown yang dibutuhkan untuk Add mode (hanya yang esensial).
		// Dropdown lain (material-type, plant, UOM, dll.) di-load lazy saat user klik.
		async loadDialogOptionsS() {
			await this.resolveAutoCompleteDefaults();
			await this.loadPriceControls();
			if (this.isTabVisibleS('MRP')) {
				await Promise.all([
					this.loadSparePartCategories(),
					this.loadMrpTypeOptions(),
				]);
			}
		},
		async loadPriceControls() {
			try {
				const res = await api(this, generalMasterDataService.list('price-controls', { client: this.clientCode }), false);
				const items = res.data?.data || res.data || [];
				this.priceControlOptions = (Array.isArray(items) ? items : []).map(pc => ({ code: pc.code, label: `${pc.code} - ${pc.description}` }));
			} catch (e) {
				console.warn('Failed to load price controls:', e);
				this.priceControlOptions = [];
			}
		},

		// === Master Data Select (generic) ===
		// Muat opsi master data jadi dropdown. Backend punya beberapa bentuk envelope
		// respons (res | res.data | res.data.data | res.data.data.data) — semua ditangani.
		// loadingKey: nama property di data() yang akan di-set true/false selama fetch
		// (opsional — dipakai untuk disable field sementara loading).
		async loadMasterDataSelectS(resource, formField, optionsKey, labelBuilder, extraParams = {}, { itemFilter, itemMapper, loadingKey, forceAll, resolveOnly } = {}) {
			if (loadingKey && this[loadingKey]) return;
			if (loadingKey) this[loadingKey] = true;
			let items = [];
		// Edit mode: pakai search param + kode tersimpan biar cuma fetch data yang relevan.
		// forceAll: skip search param → load 10 item pertama (dipakai onXxxShow saat user klik dropdown).
		// resolveOnly: hanya resolve label ke form value, tidak populate dropdown options.
		// Add mode: biarkan limit dari extraParams (default 10) supaya performa tetap ringan.
		const isEdit = Boolean(this.dialog.editingItemId);
		let apiParams;
		if (isEdit && !forceAll) {
			// Cari nilai kode yang tersimpan di form buat jadi search param
			const currentVal = this.dialog.form[formField];
			const searchCode = (currentVal && typeof currentVal === 'object')
				? (currentVal.value || currentVal.code || '')
				: (currentVal || '');
			const rest = Object.fromEntries(
				Object.entries(extraParams).filter(([k]) => k !== 'limit')
			);
			apiParams = { limit: 10, client: this.clientCode, search: String(searchCode), ...rest };
		} else {
			apiParams = { client: this.clientCode, ...extraParams };
		}
			try {
				const res = await api(this, generalMasterDataService.list(resource, apiParams), false);
				const data = Array.isArray(res) ? res : res?.data;
				items = Array.isArray(data) ? data
					: (Array.isArray(data?.data) ? data.data
						: (Array.isArray(data?.data?.data) ? data.data.data : []));
				items = items.filter(i => i && i.code !== undefined && i.code !== null);
				if (itemFilter) items = items.filter(itemFilter);
				if (!resolveOnly) {
				// Merge dengan opsi yang sudah ada (dari ensureOptionVisibleS / fetch sebelumnya)
				// supaya label yang sudah ditambahkan tidak hilang.
				const existing = new Map((this[optionsKey] || []).map(o => [String(o.value), o]));
				const mapped = items.map(itemMapper || (m => ({
					label: labelBuilder(m),
					value: String(m.code)
				})));
				mapped.forEach(o => existing.set(String(o.value), o));
				this[optionsKey] = Array.from(existing.values());
			}
			} catch (e) {
				console.warn(`Failed to load ${resource}:`, e);
				// Jangan clear options saat API error — pertahankan opsi yang sudah ada
				// (termasuk fallback dari ensureOptionVisibleS) supaya saved value tetap
				// tampil di dropdown walau API gagal. resolveMasterDataSelectValueS di
					// bawah akan menambahkan fallback jika masih kosong.
			} finally {
				if (loadingKey && loadingKey in this) this[loadingKey] = false;
			}
			this.resolveMasterDataSelectValueS(items, formField, optionsKey, labelBuilder);
		},

		// Cocokkan nilai form (kode ATAU deskripsi/nama/label) ke data API. Kalau ketemu,
		// nilai form dinormalisasi ke kode API sehingga opsi dari API yang terseleksi
		// (perilaku sama dengan AutoComplete lama yang menyimpan code).
		resolveMasterDataSelectValueS(items, formField, optionsKey, labelBuilder) {
			// Ekstraksi nilai: untuk objek {label, value} ambil value/code dulu (bukan label),
			// supaya pencocokan ke kode API tidak gagal.
			const val = this.dialog.form[formField];
			const currentRaw = (val && typeof val === 'object') ? (val.value || val.code || val.label || '') : (val || '');
			const current = currentRaw ? String(currentRaw).trim() : '';
			if (!current) return;
			const key = current.toLowerCase();
			const byCode = items.find(i => String(i.code).toLowerCase() === key);
			const byText = !byCode && items.find(i => {
				const text = String(i.description || i.name || i.label || '').trim().toLowerCase();
				const combined = `${i.code} - ${i.description || i.name || ''}`.toLowerCase();
				return text === key || combined === key;
			});
			const matched = byCode || byText;
			if (matched) {
				this.dialog.form[formField] = String(matched.code);
				// Update label jika sudah ada (dari ensureOptionVisibleS), atau tambah baru.
				const newOpt = { label: labelBuilder(matched), value: String(matched.code) };
				const existIdx = this[optionsKey].findIndex(o => String(o.value) === String(matched.code));
				if (existIdx >= 0) {
					this[optionsKey].splice(existIdx, 1, newOpt);
				} else {
					this[optionsKey].unshift(newOpt);
				}
				return;
			}
			// Fallback: nilai lama yang tidak ditemukan di list API tetap ditampilkan
			// supaya saat edit select tidak tampak kosong.
			if (!this[optionsKey].some(o => String(o.value).toLowerCase() === key)) {
				this[optionsKey] = [{ label: current, value: current }, ...this[optionsKey]];
			}
		},

		// Label opsi: pakai label API kalau ada; hindari label dobel "CODE - CODE".
		masterDataOptionLabelS(m) {
			if (m.label) return m.label;
			const desc = m.description || m.name || '';
			return String(m.code) === String(desc) ? String(desc) : `${m.code} - ${desc}`;
		},
		// Label terpilih untuk Select — fallback ke kode kalau opsi-nya belum ada di daftar
		// (mis. nilai hasil material number yang opsi-nya belum dimuat / sempat ter-reset),
		// supaya nilai tetap TAMPIL walau opsi belum ketemu.
		getSelectValueLabelS(optionsKey, value) {
			if (value == null || value === '') return '';
			// Nilai bisa berupa objek {label, value, code, ...} (data item edit / format
			// AutoComplete lama) — ambil label/code-nya dulu supaya tidak render "[object Object]".
			const raw = (typeof value === 'object') ? (value.label || value.value || value.code || '') : value;
			const v = String(raw);
			if (!v) return '';
			const match = this[optionsKey].find(o => String(o.value) === v);
			return match ? match.label : v;
		},
		// Spare Part Category (gm_sparepart_categories)
		async loadSparePartCategories(forceAll) {
			await this.loadMasterDataSelectS('gm_sparepart_categories', 'sparepart_category', 'sparePartCategoryOptions', m => this.masterDataOptionLabelS(m), {}, { loadingKey: 'sparePartCategoryLoading', forceAll });
		},

		// Standard Description di-fetch lazy: hanya saat dropdown diklik (event @show).
		// Selama proses, Select menampilkan loading via prop :loading. Flag di-reset
		// oleh clearSuggestions() saat dialog ditutup.
		async onStandardDescriptionShow() {
			if (this.standardDescriptionLoading) return;
			this.standardDescriptionLoading = true;
			try {
				await this.loadStandardDescriptions(true);
			} finally {
				this.standardDescriptionLoading = false;
			}
		},

		// Standard Description (gm_standard_description_users) — hanya 10 opsi pertama dimuat.
		async loadStandardDescriptions(forceAll, resolveOnly) {
			await this.loadMasterDataSelectS('gm_standard_description_users', 'standard_description', 'standardDescriptionOptions', m => this.masterDataOptionLabelS(m), { limit: 10 }, { forceAll, resolveOnly });
		},

		// Equipment di-fetch lazy: hanya saat dropdown diklik (event @show).
		async onEquipmentShow() {
			if (this.equipmentLoading) return;
			this.equipmentLoading = true;
			try {
				await this.loadEquipmentOptions(true);
			} finally {
				this.equipmentLoading = false;
			}
		},

		// Equipment (general-master-data/equipment) — data besar (ribuan), jadi hanya
		// 10 opsi pertama yang dimuat. Kalau query tidak ketemu di opsi yang sudah
		// dimuat, onEquipmentFilter() yang memanggil API (server-side search).
		async loadEquipmentOptions(forceAll, resolveOnly) {
			await this.loadMasterDataSelectS('equipment', 'equipment', 'equipmentOptions', m => this.masterDataOptionLabelS(m), { limit: 10 }, {
				itemMapper: m => ({ label: m.label || `${m.code} - ${m.description || m.name || ''}`, value: String(m.code) }),
				forceAll, resolveOnly,
			});
		},
		// Filter Equipment: cek dulu di 10 opsi lokal; kalau tidak ketemu → panggil
		// API search (debounce 400ms, anti query duplikat) & merge hasil ke opsi.
		onEquipmentFilter({ value }) {
			return this.onMasterDataSelectFilter('equipment', 'equipmentOptions', 'equipmentSearchedQueries', 'equipmentFilterTimer', value);
		},

		// UOM di-fetch lazy: hanya saat dropdown diklik (event @show). Selama proses,
		// Select menampilkan loading via prop :loading. Tidak di-fetch ulang dalam
		// sesi dialog yang sama — flag di-reset oleh clearSuggestions() saat tutup.
		async onUomShow() {
			if (this.uomLoading) return;
			this.uomLoading = true;
			try {
				await this.loadUomOptions(true);
			} finally {
				this.uomLoading = false;
			}
		},

		// UOM (general-master-data/uom) — pola sama seperti Equipment: hanya 10 opsi
		// pertama yang dimuat, sisanya dicari via API kalau tidak ketemu di lokal.
		async loadUomOptions(forceAll, resolveOnly) {
			await this.loadMasterDataSelectS('uom', 'uom', 'uomOptions', m => this.masterDataOptionLabelS(m), { limit: 10 }, { forceAll, resolveOnly });
		},
		onUomFilter({ value }) {
			return this.onMasterDataSelectFilter('uom', 'uomOptions', 'uomSearchedQueries', 'uomFilterTimer', value);
		},
		// Pastikan nilai tersimpan (kode) punya opsi di dropdown — kalau belum ada,
		// tambahkan sebagai opsi pertama supaya Select menampilkan nilai terpilih.
		ensureOptionVisibleS(optionsKey, formField, label, extra = {}) {
			const val = this.dialog.form[formField];
			if (val == null || val === '') return;
			const key = String(typeof val === 'object' ? (val.value || val.code || val.label || '') : val);
			if (!key) return;
			// Normalisasi nilai form ke kode string supaya Select bisa match option-value
			// (backend kadang mengirim number, mis. valuation_class, atau objek {label, value}).
			if (this.dialog.form[formField] !== key) {
				this.dialog.form[formField] = key;
			}
			if (!this[optionsKey].some(o => String(o.value) === key)) {
				this[optionsKey].unshift({ label: label || key, value: key, ...extra });
			}
		},
		// Pastikan Copy From dropdown punya opsi berlabel buat nilai tersimpan.
		// Sama seperti ensureOptionVisibleS tapi untuk copyFromXxxOptions.
		ensureCopyFromOptionS(optionsKey, formField, masterCache) {
			const val = this.dialog.copyFrom[formField];
			if (val == null || val === '') return;
			const key = String(typeof val === 'object' ? (val.value || val.code || val.label || '') : val);
			if (!key) return;
			if (this.dialog.copyFrom[formField] !== key) {
				this.dialog.copyFrom[formField] = key;
			}
			if (!this[optionsKey].some(o => String(o.value) === key)) {
				// Resolve label dari master data cache
				const match = (masterCache || []).find(o => String(o.code) === key);
				const label = match ? match.label : key;
				this[optionsKey].unshift({ label, value: key });
			}
		},

		// === Save ===
		async saveForm() {
			this.dialog.validated = true;
			this.dialog.errors = {};

			const isEmpty = (val) => {
				if (val === null || val === undefined || val === '') return true;
				if (Array.isArray(val) && val.length === 0) return true;
				if (typeof val === 'object' && Object.keys(val).length === 0) return true;
				return false;
			};

			// 1. Dynamic Validation from Form Config
			if (this.formConfig?.tab_fields) {
				Object.keys(this.formConfig.tab_fields).forEach(tabKey => {
					if (!this.isTabVisibleS(tabKey)) return;
					const fields = this.formConfig.tab_fields[tabKey];

					if (['basic_data_specification', 'description_material', 'emcr_mrp', 'notes'].includes(tabKey)) {
						Object.keys(fields).forEach(fieldName => {
							// Alias Price Unit: config bisa pakai unit_price / cat_price_unit → form pakai price_unit.
							// Lookup mandatory pakai config key, tapi error ditulis di form key supaya
							// input (:invalid="!!dialog.errors.price_unit") tetap menampilkan merah.
							const formKey = (fieldName === 'unit_price' || fieldName === 'cat_price_unit') ? 'price_unit' : fieldName;
							if (this.isFieldMandatoryS(tabKey, fieldName) && isEmpty(this.dialog.form[formKey])) {
								this.dialog.errors[formKey] = 'Field is required';
							}
						});
					}

					if (['organization_level', 'organizational_data', 'accounting'].includes(tabKey)) {
						// Handle nested structure (organizational_data has { fields, sections })
						const fieldMap = fields.fields || fields;
						Object.keys(fieldMap).forEach(fieldName => {
							const formKey = this.orgFormFieldNameS(fieldName);
							// Gunakan fieldName (original dari config, misal 'plant') untuk lookup mandatory,
							// dan formKey (mapped, misal 'ext_plant') untuk nilai & error key
							if (this.isFieldMandatoryS(tabKey, fieldName) && isEmpty(this.dialog.form[formKey])) {
								this.dialog.errors[formKey] = 'Field is required';
							}
						});
					}

					if (tabKey === 'emcr_manufacturers') {
						if (this.dialog.form.manufacturerParts.length === 0) {
							this.dialog.errors.manufacturerParts = 'Minimal 1 item required';
						} else {
							let hasRowError = false;
							this.dialog.form.manufacturerParts.forEach((part) => {
								Object.keys(fields).forEach(fieldName => {
									if (fieldName === 'notes') return;
									if (this.isFieldMandatoryS(tabKey, fieldName) && isEmpty(part[fieldName])) {
										hasRowError = true;
									}
								});
							});
							if (hasRowError) this.dialog.errors.manufacturerParts = 'Some manufacturer details are incomplete';
						}
					}

					if (tabKey === 'attachment_of_material') {
						if (this.isFieldMandatoryS(tabKey, 'file_code')) {
							if (this.dialog.form.attachments.length === 0) {
								this.dialog.errors.attachments = 'At least 1 file is required';
							}
						}
					}
				});
			}

			// 2. Custom Business Logic & Always Required Fields
			if (this.isFieldVisibleS('Basic Data & Specification', 'mcr_code') && isEmpty(this.dialog.form.mcr_code)) {
				this.dialog.errors.mcr_code = 'MCR Code is required';
			}
			if (this.hasMaterialNumberFieldS && isEmpty(this.dialog.form.material_number)) {
				this.dialog.errors.material_number = this.isService ? 'Service Number is required' : 'Material Number is required';
			} else if (this.hasMaterialNumberFieldS && !this.dialog.isMaterialSelected) {
				this.dialog.errors.material_number = this.isService ? 'Please select a service from the suggestions list to unlock the form' : 'Please select a material from the suggestions list to unlock the form';
			}

			// Aggregate errors for section headers
			const basicKeys = [];
			if (this.isFieldVisibleS('Basic Data & Specification', 'mcr_code')) basicKeys.push('mcr_code');
			basicKeys.push(...this.configFieldNamesS('Basic Data & Specification'));
			// Form key alias Price Unit (config bisa pakai unit_price/cat_price_unit) ikut di-agregasi
			if (this.isPriceUnitFieldVisibleS()) basicKeys.push('price_unit');
			if (basicKeys.some(k => this.dialog.errors[k])) this.dialog.errors.basic = 'Basic Data is incomplete';

			if (this.isTabVisibleS('MRP')) {
				const mrpKeys = this.configFieldNamesS('MRP');
				if (mrpKeys.some(k => this.dialog.errors[k])) this.dialog.errors.mrp = 'MRP Data is incomplete';
			}

			if (this.isTabVisibleS('Organization Level')) {
				const orgKeys = ['ext_plant', 'ext_location', 'ext_valuation_type', 'ext_sales_org', 'ext_dist_channel', 'ext_warehouse_number', 'ext_storage_type'];
				if (orgKeys.some(k => this.dialog.errors[k])) this.dialog.errors.org = 'Organization Level is incomplete';
			}

			if (this.isTabVisibleS('Accounting')) {
				const acctKeys = ['valuation_class', 'price_control', 'standard_price'];
				if (acctKeys.some(k => this.dialog.errors[k])) this.dialog.errors.accounting = 'Accounting is incomplete';
			}

			if (Object.keys(this.dialog.errors).length > 0) {
				this.$toastNotifPrime('warn', 'Validation Error', 'Please complete all required fields');
				return;
			}

			// --- Local Mode: emit form data without API call ---
			if (this.localMode) {
				const formData = { ...this.dialog.form };
				if (formData.material_type && typeof formData.material_type === 'object') formData.material_type = formData.material_type.value || '';
				if (formData.material_group && typeof formData.material_group === 'object') formData.material_group = formData.material_group.value || '';
				if (formData.plant && typeof formData.plant === 'object') formData.plant = formData.plant.value || '';
				if (formData.uom && typeof formData.uom === 'object') formData.uom = formData.uom.value || '';
				if (formData.service_group && typeof formData.service_group === 'object') formData.service_group = formData.service_group.value || '';
				if (formData.service_category && typeof formData.service_category === 'object') formData.service_category = formData.service_category.value || '';
				if (formData.sparepart_category && typeof formData.sparepart_category === 'object') formData.sparepart_category = formData.sparepart_category.value || '';
				if (formData.standard_description && typeof formData.standard_description === 'object') formData.standard_description = formData.standard_description.value || '';
				if (formData.valuation_class && typeof formData.valuation_class === 'object') formData.valuation_class = formData.valuation_class.value || '';
				if (formData.mrp_type && typeof formData.mrp_type === 'object') formData.mrp_type = formData.mrp_type.value || '';
				if (formData.lot_size && typeof formData.lot_size === 'object') formData.lot_size = formData.lot_size.value || '';
				if (formData.abc_indicator && typeof formData.abc_indicator === 'object') formData.abc_indicator = formData.abc_indicator.value || '';

				this.dialog.internalVisible = false;
				this.$emit('saved', { form: formData, editIndex: this.dialog.editingItemId });
				return;
			}

			// --- API Mode ---
			this.dialog.onLoading = true;
			try {
				const form = this.dialog.form;

				// Helper: extract value from AutoComplete object or string
				const extractValue = (val) => {
					if (val && typeof val === 'object') return val.value || val.code || val.label || '';
					return val || '';
				};

				// Helper: check if a tab is visible via form config
				const tabVisible = (tab) => this.isTabVisibleS(tab);
				const fieldVisible = (tab, field) => this.isFieldVisibleS(tab, field);

				// Build flat payload — only include values from VISIBLE tabs
				// buildFormData() in userFormService will handle nesting
				const payload = {
					client: this.clientCode,
					mcr_type: this.mcrType,
				};

				// === Basic Data & Specification (always included) ===
				if (tabVisible('Basic Data & Specification')) {
					const bs = 'Basic Data & Specification';
					payload.mcr_code = form.mcr_code || '';
					if (fieldVisible(bs, 'material_number')) payload.material_number = form.material_number_raw || extractValue(form.material_number);
					if (fieldVisible(bs, 'material_type')) payload.material_type = extractValue(form.material_type);
					if (fieldVisible(bs, 'material_group')) payload.material_group = extractValue(form.material_group);
					if (fieldVisible(bs, 'plant')) payload.plant = extractValue(form.plant);
					if (fieldVisible(bs, 'uom')) payload.uom = extractValue(form.uom);
					if (fieldVisible(bs, 'equipment')) payload.equipment = extractValue(form.equipment);
					if (fieldVisible(bs, 'currency')) payload.currency = form.currency || '';
					if (fieldVisible(bs, 'price_reference')) payload.price_reference = form.price_reference || '';
					if (this.isPriceUnitFieldVisibleS()) payload.price_unit = form.price_unit ?? '';
					if (fieldVisible(bs, 'service_group')) payload.service_group = extractValue(form.service_group);
					if (fieldVisible(bs, 'service_category')) payload.service_category = extractValue(form.service_category);
					if (fieldVisible(bs, 'specification') || this.isFieldVisibleS('description_material', 'specification')) payload.specification = form.specification || '';
					if (fieldVisible(bs, 'valuation_class')) payload.valuation_class = extractValue(form.valuation_class);
					if (fieldVisible(bs, 'standard_description')) payload.standard_description = extractValue(form.standard_description);
					if (fieldVisible(bs, 'estimated_annual_usage')) payload.estimated_annual_usage = form.estimated_annual_usage || '';
					if (fieldVisible(bs, 'repairable_item')) payload.repairable_item = form.repairable_item;
					if (fieldVisible(bs, 'item_type')) payload.item_type = form.item_type || '';
				}

				// === MRP Data (selalu dikirim meskipun tab tidak visible) ===
				payload.sparepart_category = extractValue(form.sparepart_category);
				payload.mrp_type = extractValue(form.mrp_type);
				payload.lot_size = extractValue(form.lot_size);
				payload.reorder_point = form.reorder_point != null ? form.reorder_point : '';
				payload.safety_stock = form.safety_stock != null ? form.safety_stock : '';
				payload.abc_indicator = extractValue(form.abc_indicator);
				payload.maximum_stock_level = form.maximum_stock_level != null ? form.maximum_stock_level : '';
				payload.rounding_value = form.rounding_value != null ? form.rounding_value : '';

				// === Manufacture ===
				if (tabVisible('Manufacture')) {
					payload.manufacturerParts = (form.manufacturerParts || []).map((p, idx) => ({
						manufacture: typeof p.manufacture === 'object' ? (p.manufacture?.code || p.manufacture?.value || '') : (p.manufacture || ''),
						manufacture_ref: p.manufacture_ref || '',
						manufacture_ref_description: p.notes || p.manufacture_ref_description || '',
						source_type: p.source_type || '',
						manref_type: p.manref_type || '',
						position: p.position || (idx + 1),
					}));
				} else {
					payload.manufacturerParts = [];
				}

				// === Equipments ===
				payload.equipmentItems = (form.equipments || []).map(eq => ({
					plant: eq.plant || extractValue(form.ext_plant) || extractValue(form.plant),
					equipment: eq.equipment || '',
					qty_installed: eq.qty_installed != null ? eq.qty_installed : '',
				}));

				// === Organization Level ===
				if (tabVisible('Organization Level')) {
					const org = 'Organization Level';
					payload.ext_plant = extractValue(form.ext_plant) || extractValue(form.plant) || '';
					if (fieldVisible(org, 'location') || fieldVisible(org, 'storage_location')) payload.ext_location = extractValue(form.ext_location) || '';
					if (fieldVisible(org, 'valuation_type')) payload.ext_valuation_type = extractValue(form.ext_valuation_type) || '';
					if (fieldVisible(org, 'sales_org')) payload.ext_sales_org = extractValue(form.ext_sales_org) || '';
					if (fieldVisible(org, 'distribution_channel') || fieldVisible(org, 'distr_channel')) payload.ext_dist_channel = extractValue(form.ext_dist_channel) || '';
					if (fieldVisible(org, 'warehouse_no')) payload.ext_warehouse_number = extractValue(form.ext_warehouse_number) || '';
					if (fieldVisible(org, 'storage_type')) payload.ext_storage_type = extractValue(form.ext_storage_type) || '';

					// Copy From fields
					const cf = this.dialog.copyFrom || {};
					payload.ext_cf_plant = extractValue(cf.ext_cf_plant) || '';
					payload.ext_cf_location = extractValue(cf.ext_cf_location) || '';
					payload.ext_cf_valuation_type = extractValue(cf.ext_cf_valuation_type) || '';
					payload.ext_cf_sales_org = extractValue(cf.ext_cf_sales_org) || '';
					payload.ext_cf_dist_channel = extractValue(cf.ext_cf_dist_channel) || '';
					payload.ext_cf_warehouse_number = extractValue(cf.ext_cf_warehouse_number) || '';
					payload.ext_cf_storage_type = extractValue(cf.ext_cf_storage_type) || '';
				}

				// === Accounting (valuations) ===
				if (tabVisible('Accounting')) {
					payload.emcr_valuations = [];
					if (form.price_control || form.standard_price != null) {
						payload.emcr_valuations.push({
							valuation_area: extractValue(form.ext_plant) || extractValue(form.plant) || '',
							valuation_class: extractValue(form.valuation_class),
							price_control: form.price_control || '',
							std_price: form.standard_price != null ? form.standard_price : '',
						});
					}
				}

				// === Notes ===
				if (tabVisible('Notes') && form.notes) {
					payload.notes = form.notes;
				}

				// === Attachments ===
				payload.attachments = form.attachments || [];

				// Submit via userFormService (buildFormData converts to multipart FormData)
				if (this.dialog.editingItemId) {
					await api(this, userFormService.update(this.dialog.editingItemId, payload), true);
				} else {
					await api(this, userFormService.create(payload), true);
				}

				this.dialog.internalVisible = false;
				this.$emit('saved');

			} catch (error) {
				console.error('Error in saveForm:', error);				} finally {
					this._skipResetDisabled = false;
					this.dialog.onLoading = false;
				}
			},

		// === Parsing helpers ===
		parseNotesS(notesData) {
			if (!notesData) return '';
			if (typeof notesData === 'string') {
				try {
					const parsed = JSON.parse(notesData);
					if (Array.isArray(parsed)) return parsed.map(n => n?.notes ?? n ?? '').join('\n');
					return notesData;
				} catch { return notesData; }
			}
			if (Array.isArray(notesData)) return notesData.map(n => n?.notes ?? '').join('\n');
			return notesData?.notes ?? '';
		},
		parseManufacturerPartsS(manufacturerData) {
			if (!manufacturerData) return [{ manufacture: '', manufacture_ref: '', notes: '' }];
			const toRow = (m) => ({ manufacture: m?.manufacture || '', manufacture_ref: m?.manufacture_ref || '', notes: m?.notes || '' });
			return Array.isArray(manufacturerData) ? manufacturerData.map(toRow) : [toRow(manufacturerData)];
		},
		parseAttachmentsS(attachmentData) {
			if (!attachmentData) return [];
			const toRow = (a) => ({
				name: a?.file_attachment?.original_filename || a?.file_attachment?.file_name || a?.file_code || '',
				size: a?.file_attachment?.file_size ? Number(a.file_attachment.file_size) : 0,
				file_code: a?.file_code || '',
				file_attachment_id: a?.file_attachment?.id || null,
				mime_type: a?.file_attachment?.mime_type || ''
			});
			return Array.isArray(attachmentData) ? attachmentData.map(toRow) : [toRow(attachmentData)];
		},
	},
};
</script>

<style scoped>
:deep(.compact-table .p-datatable-tbody > tr > td) {
	padding: 0.35rem 0.5rem;
}

:deep(.compact-table .p-datatable-thead > tr > th) {
	padding: 0.4rem 0.5rem;
}

:deep(.p-datatable-sm .p-datatable-tbody > tr > td) {
	font-size: 0.875rem;
	padding: 0.35rem 0.5rem;
}

:deep(.p-datatable-sm .p-datatable-thead > tr > th) {
	font-size: 0.875rem;
	padding: 0.4rem 0.5rem;
}

:deep(.add-item-modal .p-inputtext-sm) {
	padding: 0.3rem 0.4rem;
}

.pdf-iframe {
	width: 100%;
	height: 80vh;
	border: none;
	border-radius: 0 0 12px 12px;
}

/* Section cards for Organization Level (SAP-style) */
:deep(.org-card) {
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	overflow: hidden;
}

:deep(.org-card-header) {
	background-color: #f8f9fa;
	border-bottom: 1px solid #e5e7eb;
	font-size: 0.875rem;
	color: #374151;
}

:deep(.org-field) {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	margin-bottom: 0.6rem;
}

:deep(.org-label) {
	flex: 0 0 40%;
	max-width: 40%;
	font-size: 0.8rem;
	font-weight: 600;
	color: #374151;
	margin-bottom: 0;
}

:deep(.org-input) {
	flex: 1 1 60%;
	min-width: 0;
}

:deep(.copy-field) {
	margin-bottom: 0.6rem;
}

:deep(.org-col-divider) {
	border-left: 1px solid #e5e7eb;
}

/* Panel dropdown Standard Description dibuat ringkas supaya ukurannya sama seperti
   panel AutoComplete lain. Wajib :global() — overlay PrimeVue di-teleport ke <body>
   (di luar scope komponen), jadi :deep() tidak pernah kena. */
:global(.standard-desc-panel) {
	/* Panel PrimeVue di-set min-width = lebar input (Select.vue onOverlayEnter),
	   jadi tanpa cap ini panel ikut melebar mengikuti label opsi yang panjang. */
	max-width: 32rem;
}

:global(.standard-desc-panel .p-select-filter-container) {
	padding: 0.35rem 0.5rem;
}

:global(.standard-desc-panel .p-select-filter) {
	/* Samakan persis dengan input size="small" lain (token Aura sm: font-size
	   0.875rem, padding 0.375rem 0.625rem) — jangan hard-code tinggi sendiri. */
	font-size: 0.875rem;
	padding: 0.375rem 0.625rem;
}

:global(.standard-desc-panel .p-select-option),
:global(.standard-desc-panel .p-select-option-label) {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>